export const en = {
    "k_6db841d5": "Default red",
    "k_158de5dd": "PCG blue",
    "k_670d606a": "Tencent Blue",
    "k_88054631": "Sky blue",
    "k_4e9d4bb6": "Page/link jump failed: {arg_0}",
    "k_fa57d441": "Invalid page path",
    "k_ce12e0f9": "Path resolution failed: Dynamic path parameters cannot be empty",
    "k_ecdd0af9": "Dynamic path resolution failed",
    "k_67bd925c": "File names cannot contain Chinese characters",
    "k_8ac70fc4": "Unresponsive",
    "k_c4097d2": "The response content is incorrect",
    "k_840f84df": "The loadAmdModule function call is missing the necessary amdKey parameter",
    "k_f73092c": "Application information",
    "k_effb261f": "Release management",
    "k_e5f6f1": "Authorized",
    "k_62caf1cb": "Log| data",
    "k_d01cf670": "Rights management",
    "k_78539ebc": "Set",
    "k_25bcc5f5": "Page list",
    "k_3a98802c": "Add page",
    "k_3839254f": "Label management",
    "k_e3c46e83": "Generic configuration",
    "k_f4c7d984": "Application ID",
    "k_8828fcda": "Apply Chinese names",
    "k_6d2a8848": "Described",
    "k_8fc3cc81": "Type",
    "k_c8827c39": "Operating products",
    "k_89b814e7": "Managers",
    "k_3fb5305c": "Developers",
    "k_7e42d01e": "Page theme color",
    "k_3b2d9eab": "Design style",
    "k_b58f0075": "Default layout style",
    "k_1f227f74": "Web page icon",
    "k_adc0f26c": "Web page icons (favicon) Configure the icons displayed in tabs by the browser",
    "k_e229c4dc": "Home",
    "k_4a6b04b5": "Pages redirected by the application home page and root path (/); support configuring pages with page path as/as the default application home page",
    "k_a98630c": "403 Redirect",
    "k_a00fcd6d": "The page redirected when requesting the interface to return to 403",
    "k_c955c0dd": "Hide page progress bar",
    "k_6d26d2b6": "Whether to hide the loading progress bar at the top of the page",
    "k_e74d3713": "Message reminder style",
    "k_6d8df820": "Defines how to display error messages when the page is running. The default is \"Notification floating layer\"",
    "k_5ec25129": "Watermarking function",
    "k_6c148ff2": "What is turned on here is the global watermark function (effective for all pages). If you want a single page to take effect, please go to the page to set it separately.",
    "k_b3ab77c6": "Xiaoman feedback",
    "k_1975746f": "What is opened here is the small full function of the formal environment.",
    "k_7d88b15f": "Xiaoman is a platform for satisfaction feedback, and Xiaoman ID is the unique ID of your management platform.",
    "k_262efe35": "If you need to understand Xiaoman related content and generate Xiaoman ID, you can go to Xiaoman's official website.",
    "k_b58db0f1": "Front-end monitoring",
    "k_22d48703": "What is turned on here is the platform's built-in runtime front-end monitoring.",
    "k_d8fc33e3": "Opening helps the platform locate specific issues more quickly",
    "k_ddf5b5ce": "Agent reporting",
    "k_581b029f": "The default is turned off, and the front-end is used to report directly during runtime",
    "k_a1a4e2f2": "When turned on, use a background agent for reporting at runtime",
    "k_1aef2bf6": "Announcement",
    "k_4537ec7d": "Open here is the edit time station announcement configuration, and runtime station announcement display",
    "k_a1ce8a13": "Application navigation",
    "k_334838e7": "App navigation is the navigation configuration for all pages at runtime, with lower priority than individual page configurations",
    "k_7bd7538b": "Application menu",
    "k_f95d97ec": "The application menu is the menu configuration of all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_497394ec": "Application header",
    "k_5971652d": "The application header is configured for all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_bbf1b556": "Application Footer",
    "k_417624d8": "The application footer is the footer configuration of all pages at runtime, and has lower priority than the individual configuration of pages",
    "k_5ffa78f0": "Visible range",
    "k_60b8cd55": "Extended configuration",
    "k_f4b30c19": "Custom layout component configuration",
    "k_6dd2204": "Global Route Guard",
    "k_9af4f39a": "Enterprise WeChat application configuration",
    "k_6830ea57": "Apply LessCode",
    "k_70adca95": "Global script configuration",
    "k_c71f0afd": "Global icon configuration",
    "k_e2df3a9b": "Front-end monitoring configuration",
    "k_f1a19541": "Top navigation",
    "k_3988cc00": "User information",
    "k_fa393bc": "Application name",
    "k_f820b5d3": "Application Logo",
    "k_868fb9ab": "Context switch",
    "k_3a69a78e": "Help documentation",
    "k_1da199be": "I want feedback",
    "k_b5030ba1": "Application Quick Switch Panel",
    "k_5be772f": "Fixed head navigation",
    "k_10809af6": "Display page hierarchy",
    "k_67139b0a": "Use breadcrumbs below the navigation to show the hierarchical relationship of the page. Example:<br/>",
    "k_66db464c": "Primary catalog/Secondary catalog/Page xxx",
    "k_bb5cc522": "Display recent access routes",
    "k_29589bc5": "Display recently visited pages below the navigation to facilitate rapid business jumps",
    "k_195837bc": "Display watermarks to distinguish environments",
    "k_eec2d063": "Watermarks are displayed in the navigation bar of the development environment and test environment to prevent erroneous operations",
    "k_16c0c46b": "Common query parameters",
    "k_475fb85c": "The configuration of public query parameters is spliced into the linked query parameters in the form of key = value, and the components that switch parameters are displayed in the top navigation bar.",
    "k_caf66673": "Enable business isolation",
    "k_7bf9b398": "Menu group",
    "k_ad9f2f34": "Right Express Entrance",
    "k_933a2fcb": "Navigation bar component",
    "k_3eabc597": "Default avatar drop-down menu",
    "k_ade06fae": "Customize avatar drop-down menu",
    "k_2df809bb": "Permission configuration",
    "k_c7e1579": "Left menu",
    "k_bd1e62a1": "Menu width",
    "k_c063b925": "Menu option configuration",
    "k_3dd5ca22": "Display application title",
    "k_35790c25": "Display menu title",
    "k_85ae821": "Expand submenu by default",
    "k_cd400996": "Accordion mode",
    "k_30d6e973": "After opening, the left menu will only expand the currently selected menu items, and other menu items will not expand",
    "k_f4ca9fba": "Display search box",
    "k_eb778ee1": "Menu configuration",
    "k_93c10ead": "Approval process",
    "k_e4aba93f": "Workflow",
    "k_1d522a5f": "High level flow",
    "k_ba4882ab": "Recording is performed",
    "k_e70cbccf": "Global configuration",
    "k_462caeed": "Data source",
    "k_d321f1c": "Release record",
    "k_2b12108c": "Environmental management",
    "k_7e3424ab": "Component management",
    "k_257d514f": "Offline tasks",
    "k_fa6c49f3": "Application related authorization",
    "k_d2b28cc0": "Authorization database",
    "k_499bf85a": "Component store authorization",
    "k_6829d7d0": "Application key",
    "k_761886c2": "Apply COS",
    "k_973832d7": "Access third-party authentication",
    "k_cd60b798": "Set up third-party authentication interface",
    "k_a7b6ece3": "Back-end authentication data source ",
    "k_e3b361f4": "First set the data source of the third-party authentication interface type",
    "k_9c629ef": "Links to third-party rights systems",
    "k_bc7a0f47": "Log query",
    "k_16a0397a": "Role management",
    "k_54d7bddb": "User management",
    "k_dc0e1e5d": "Custom permission",
    "k_97f9a523": "Interface management",
    "k_1f38dc46": "Advanced configuration",
    "k_ad86af63": "Announcement management",
    "k_1bb54a86": "Branch management",
    "k_71363dc9": "Open multiple branches",
    "k_7e903cb4": "After opening, the default branch is the master branch. Users can create or switch branches, and the operations between branches are independent of each other.",
    "k_666b5a1a": "Branch protection",
    "k_6de8fef8": "After opening, users will not be allowed to make modifications directly in the master. They can only update the master through branch merge",
    "k_4f801b54": "Branch association environment",
    "k_51558cf0": "After opening, when a branch is created, the environment associated with the branch will be created and published at the same time; when the branch is deleted, the associated environment will also be deleted",
    "k_9f615023": "Publish settings",
    "k_30fd9431": "Delete application",
    "k_b3183783": "Open a pre-release environment",
    "k_f6b7caaa": "Before releasing the formal environment, you will first publish to the pre-release environment by default, and then continue to publish to the formal environment after passing the verification. The process is as follows:",
    "k_62dbaf6c": "Open heuristic approval",
    "k_282b7d04": "Versions need to be approved to be released to the formal environment before they can be released to the formal environment. The default approver is the direct superior",
    "k_d61c975": "Allow release directly from the development environment to the official environment",
    "k_ff732bad": "Start the publish or rollback push process",
    "k_2e419d63": "Editor settings",
    "k_51b2997": "Enable ESLint checking",
    "k_ad9b7477": "After configuration, you can get ESLint check in the LessCode editor",
    "k_21a8cf5f": "ESLint configuration",
    "k_3f99db0b": "Illegal path,key={arg_0}",
    "k_fa6ef644": "Monaco Editor failed to load [{arg_0}]",
    "k_c5058dce": "Using the current version",
    "k_dc2406bd": "Use remote versions",
    "k_e0ef16ad": "Keep both versions",
    "k_653018a6": "JSON check failed",
    "k_73a2bbd": "Please manually resolve the following conflicts:",
    "k_fec0159b": "Conflict pending",
    "k_6f43491a": "The previous",
    "k_4c2d66eb": "The next",
    "k_6124063b": "Flag conflict resolved",
    "k_bbdbcc3a": "Do not merge, save directly locally",
    "k_f2f7b4d0": "Have been merged",
    "k_7e7ce184": "To be solved",
    "k_96e5aa9a": "Unmerge",
    "k_2ebe236b": "Consolidated",
    "k_fa9620cb": "Conflict resolution",
    "k_a724d646": "Compile {arg_0}",
    "k_d4789591": "Compilation of {arg_0} failed: {arg_1}",
    "k_59a1f6f8": "Compile {arg_0} failed:",
    "k_959f0002": "Current change",
    "k_1ba1a0a8": "<<<<<<< {arg_0}",
    "k_2e76ac78": "Latest change",
    "k_a14e0497": ">>>>>>> {arg_0}",
    "k_89af5848": "There is a conflict with the modification merge of {arg_0} into {arg_1}. Please manually resolve the conflict and submit the merge.",
    "k_32eb4eb8": "Application configuration",
    "k_8d7ed5eb": "Navigation and menus",
    "k_3cf11e77": "Global LessCode",
    "k_b446678d": "Head script",
    "k_9ada019f": "Body Script",
    "k_c61b4dc4": "Project Module ({arg_0})",
    "k_67fa32f": "Page information",
    "k_ff930951": "{arg_0} Layout",
    "k_1e7b8328": "Missing necessary parameters for three-way merge",
    "k_705a90ff": "{arg_0} Services: {arg_1}",
    "k_953d8775": "Saved successfully",
    "k_abda9ac5": "Some fields failed to save",
    "k_9ea11a90": "Save failed",
    "k_8af2804d": "Merge failed, save and cancel",
    "k_96294861": "The loading function already exists",
    "k_cfad831b": "[FormObject] Getting an unloaded formProp is not allowed, path={arg_0}",
    "k_adcd509a": "[FormObject] Duplicate key loading is not allowed, key={arg_0}",
    "k_2d0699f3": "Duplicate loading is not allowed, key={arg_0}, bizId={arg_1}, path={arg_2}",
    "k_9b9ea9f1": "Basic data",
    "k_82edf9a3": "Field prop configuration not found, key={arg_0}",
    "k_3578a595": "There is a conflict in modifying the merge. Please manually resolve the conflict and submit the merge.",
    "k_b6d126e4": "MaterialContainer: config cannot be empty",
    "k_4170fc6": "MaterialContainer: id {arg_0} has been used. Please change it to another id",
    "k_f455a003": "[routeFactory] Unable to find the corresponding materialId: {arg_0}",
    "k_3fed3f2a": "Announcement",
    "k_bf1560fe": "To-do",
    "k_aa0a6c6b": "Skip to edit page",
    "k_67996ed": "Access using Mini programs",
    "k_ef5d61e6": "Default",
    "k_338ab8ee": "Menu",
    "k_a42df797": "Drop-down menu",
    "k_3864f490": "Application",
    "k_be33ba71": "CLI tool did not start debugging command. Please check and try again",
    "k_3280a516": "The https service is started locally, but the client requests the http interface.",
    "k_4050befb": "Switching to https",
    "k_4aafc102": "The http service is started locally, but the client requests the https interface.",
    "k_22614c2f": "Switch to http",
    "k_977bee88": "Local developer tools launch https debugging mode",
    "k_69809c15": "Development tools how to turn on https local services",
    "k_816f4da": "The https page prohibits loading http resources, so loading local development resources failed.",
    "k_671d3581": "Pages are reloaded using http",
    "k_91f3e981": "Module",
    "k_a5064e7f": "Determine",
    "k_83ed1744": "Cancel",
    "k_f426d5ff": "Unfortunately, loading local development {arg_0} failed",
    "k_e5c96995": "The request for the local development interface failed, which is usually caused by restrictions set by the browser. You can follow the following instructions to investigate one by one:",
    "k_a2cdd30b": "Scene",
    "k_ae5a5c54": "- The console reported an error:",
    "k_8a3cf94f": "Solution",
    "k_71f8a256": "The request for local development interface failed. Please use Chrome browser for development",
    "k_28623d39": "Assembly",
    "k_25f31498": "Initialize the hmr of the component",
    "k_566711a": "Loading failed. Please save the page and refresh it",
    "k_4c8ca400": "Component loading...",
    "k_1728204c": "Initialization component store request:{arg_0}",
    "k_70468b0a": "Component {arg_0} is blocked from instantiation because of the url parameter",
    "k_74c72245": "[simple-hook][{arg_0}] execution failed:",
    "k_a6f1b0f4": "There are editors that are opened repeatedly",
    "k_27c2888e": "You have opened another editor on the same page",
    "k_6dcc9c5c": "The preview function of the current editor has been suspended",
    "k_c14c8fff": "Activate the current editor",
    "k_5db66351": "Close the prompt",
    "k_496f68fc": "Data source is updated",
    "k_5224f09c": "Force reload",
    "k_51770493": "Project information modification",
    "k_40cc9bd3": "Logic or data source changes",
    "k_d5ca7a1e": "Component framework switching hook compilation failed",
    "k_9f139ac3": "Please resolve conflicts",
    "k_13c95a70": "Local lagging remote modifications have been automatically merged",
    "k_e04a289d": "There is a conflict between the current version and the latest version. Please resolve the conflict and save it",
    "k_c760bc65": "Current version",
    "k_946da0be": "Latest version",
    "k_4c057df1": "Failed to detect application ID",
    "k_3d1fff4c": "Failed to pull application data: {arg_0}",
    "k_64fcd9c": "Failed to switch project to obtain data: {arg_0}",
    "k_3df9b7d6": "Merge application modification conflict failed, cancel saving",
    "k_8b3fa3c9": "Saved successfully (local lagging remote modifications have been merged)",
    "k_7675c03d": "Failed to obtain application settings:{arg_0}",
    "k_c6e2835e": "Failed to obtain permission setting:{arg_0}",
    "k_8c7535ce": "Load failed",
    "k_26490786": "Page resource loading failure was detected. Please refresh the page and try again",
    "k_3ac2cf99": "Refresh the page",
    "k_2e43c98f": "Failed to obtain cookies: {arg_0}",
    "k_25a56892": "Automatic filling in when initiating",
    "k_35b9cacb": "Page slice",
    "k_b35069c8": "Process example details",
    "k_956ecf04": "Unnamed folding panel",
    "k_e6b58562": "Flowsheet ID: `{{job.id}` /URL",
    "k_c4fbc89d": "Replication",
    "k_ba3128ef": "Job.id displayed when creating a new process sheet",
    "k_c207e9e8": "Current approvers: {{ job.currentApprovers||  '... ' }}",
    "k_73e8a755": "Copy information + one-click group activation",
    "k_3da3caaa": "Copy information",
    "k_11589b60": "Hello, please pay attention to the approval document \"{{ job.title }}\"\n\n{{ job.url }}",
    "k_1173bad5": "Process is running",
    "k_d649582a": "Process: {{ job.title }}",
    "k_f7508b44": "Refresh",
    "k_59b4978": "Page",
    "k_4548279c": "Page JS resource loading failed",
    "k_a8e2ba8e": "Length of page stay",
    "k_f669486d": "Element click",
    "k_97462910": "Elemental exposure",
    "k_d7cfe3a8": "Elemental behavior",
    "k_d5792003": "Other component behavior events other than the \"element click\" event (such as switching tabs, the behavior ID needs to be filled in \"${component ID}:${event ID}\")",
    "k_7b830b83": "Total number of visits",
    "k_f1226738": "Total visitors",
    "k_6161add9": "Per capita number",
    "k_714deb0d": "Stay time [Average: seconds]",
    "k_b6581704": "Stay duration [Maximum: seconds]",
    "k_8d48a539": "Extended field {arg_0}",
    "k_7174abb5": "Component path",
    "k_b4a8e78b": "Modify",
    "k_5ea52ff6": "Error in page operation request parameter",
    "k_a327c337": "Failed to obtain page list",
    "k_f8a42775": "Merge page modification conflict failed, cancel saving",
    "k_f61e0369": "Failed to pull page data: {arg_0}",
    "k_803f7289": "Development environment",
    "k_5a4c29f0": "Test environment",
    "k_49cd5983": "Formal environment",
    "k_c858e1d2": "Pre-release environment",
    "k_6983648b": "Failed to obtain application environment list",
    "k_65ff08f8": "This environment is already in use by the system. Please set another environment id.",
    "k_1be7444b": "{arg_0} The environment has not been released yet, and there is no comparable version currently",
    "k_32152ba5": "Failed to obtain current page version differences:{arg_0}",
    "k_62652f5c": "Failed to submit version:{arg_0}",
    "k_6121940c": "Failed to get version list:{arg_0}",
    "k_75bb38e3": "Release failed:{arg_0}",
    "k_25723de0": "Failed to obtain current application version list:{arg_0}",
    "k_c6869e21": "Failed to synchronize environment data:{arg_0}",
    "k_5a50c201": "Failed to obtain version release content",
    "k_a1dc90c0": "Version termination failed:{arg_0}",
    "k_773e03d4": "Operation failed {arg_0}",
    "k_e06499d": "Import is successful",
    "k_75fe854": "Import failed: {arg_0}",
    "k_4ebe7f51": "Failed to execute pre-hook: {arg_0}",
    "k_ff20d88b": "Failed to get import hook: {arg_0}",
    "k_5c5e3d06": "Page loading failed,{arg_0}",
    "k_20db7ab8": "[getPageDetail] JSON.parse failed",
    "k_bcd15456": "Agreed",
    "k_46f0b9ac": "Rejected",
    "k_54e0c700": "Missing nodeId",
    "k_62c780f5": "Capture process",
    "k_4876b2f7": "Flow id",
    "k_3e9b02f0": "Approval",
    "k_171f4a68": "Approval node id",
    "k_279f7fb6": "Agree/Rejection",
    "k_b18fa4f2": "Approval opinions",
    "k_7e41b35c": "Form data",
    "k_cd38bccc": "Initiate process",
    "k_6faa5926": "Process data",
    "k_9047817e": "Get process configuration",
    "k_16a7ee42": "Get approval node information",
    "k_cb6d514f": "Get log node information",
    "k_a7ef3e87": "Get the full process",
    "k_10eb0273": "Title",
    "k_69738fe5": "Process title, empty string is not filtered",
    "k_6cf18673": "Sponsor",
    "k_28f4b25a": "Initiator, empty string is not filtered",
    "k_74c6885e": "Obtaining process based on type",
    "k_b809779": "Process type",
    "k_3aff6028": "I initiated it.",
    "k_a5c4ef48": "That I'm involved",
    "k_d2e41051": "About me",
    "k_619e3485": "Examination and approval daiban",
    "k_d4ee9699": "Id: page ID; path: page path; query: query parameters; params: routing parameters",
    "k_b4051f8": "Page ID",
    "k_1e6ffc69": "Page name",
    "k_d7996547": "Page title",
    "k_8e33b139": "Page path",
    "k_4c403e": "Global constants",
    "k_6b2526c": "Department ID",
    "k_19d85b52": "Department IDs(semicolon; split)",
    "k_804e17d3": "Center IDs(semicolon; split)",
    "k_a38949fb": "Positions",
    "k_c095a944": "Log in to channel front-end data",
    "k_64fd4991": "You can use the login channel-login hook, according to business needs, visit ctx.frontendData.xxx =... inject data",
    "k_a6701c4b": "Front-end API",
    "k_b2d9b5a4": "Open the pop-up window",
    "k_1b18feb6": "Open the specified pop-up window on the current page",
    "k_9d4adcb": "Pop-up window id that needs to be opened",
    "k_7fbf2423": "Open the parameter transfer of the pop-up window (optional)",
    "k_87bb5e80": "Close the pop-up window",
    "k_6b86856d": "Close the specified pop-up window on the current page",
    "k_e40a39c8": "Id of the pop-up window that needs to be closed (optional, when the parameter is empty, it means that the currently called pop-up window is closed)",
    "k_4a9f930d": "Return value of closing pop-up window (optional)",
    "k_489b7125": "Open global pop-up window",
    "k_1c4ee350": "Open a global pop-up window with page type of pop-up window",
    "k_f9df9c": "ID of the global pop-up window that needs to be opened (pop-up page id)",
    "k_c9b86b9f": "Open the transfer parameters of the global pop-up window",
    "k_7dc3e87e": "Configuration item for the global pop-up window, whether keepAlive retains the instance, suffix used to distinguish the instance",
    "k_2fa4e109": "Close the global pop-up window",
    "k_b81bddf8": "Close global pop-ups with page type pop-ups",
    "k_8d94ad51": "\"Global pop-up window id_suffix suffix\" that needs to be closed (\"Pop-up window page id_suffix \")",
    "k_a3efaa1f": "Return value of closing global pop-up window",
    "k_866e07f7": "Turn off the configuration item of the global pop-up window. Do you want to destroy the instance?",
    "k_7b38c09a": "Initiate an HTTP network request",
    "k_105269e2": "The return value is the object after json. parse, other things are consistent with the fetch API",
    "k_f72363bb": "Request resource address",
    "k_cbea7ea4": "Request parameters",
    "k_ecfdad6e": "Call cloud function",
    "k_ed3d16ac": "Cloud function id",
    "k_18bc59c2": "Axios configuration parameters for transparent transmission (optional)",
    "k_dac74fd4": "Request data source interface",
    "k_45f01792": "Data source ID",
    "k_a10bbcc": "Interface id of the data source",
    "k_c342f7d1": "Request parameters for the data source (optional)",
    "k_eacb5a52": "URL parameter",
    "k_150993ae": "Post parameters",
    "k_77be7d06": "Request header",
    "k_1ce66f0f": "Url path parameter, unique to front-end data sources",
    "k_758587d2": "Wait until all data sources are ready",
    "k_1013a9c9": "This method ensures subsequent calls of logical data source variables and methods",
    "k_179b3b81": "Get the values of public parameters based on key",
    "k_f7f034fd": "Public parameter key",
    "k_634e9504": "Options to get public parameters based on key",
    "k_f517814e": "Option to re-request public parameters based on key",
    "k_af9a1d3b": "The common parameter component options in the upper left corner of the top navigation are also updated after the request is completed",
    "k_385deb37": "Method for judging user rights",
    "k_30435cfb": "Determine whether the current user has custom permissions, such as: w. hasPermission (\"custom-permission-id \")",
    "k_df46af87": "Permission ID (for example,`\"custom-permission-id\"`)",
    "k_ad5d6da": "Jump page",
    "k_d59cac02": "Skip to the specified page within the app and keep the current page",
    "k_fdfafdf3": "Skip to the specified page in the app and close the current page",
    "k_f6561836": "New window opens page",
    "k_7ffd6bb3": "New window opens the specified page",
    "k_d70a0368": "Get the resolved page path",
    "k_cc480ccb": "Scroll the page to the target location",
    "k_7b0316b3": "Scroll parameters, please check the front-end API documentation for details",
    "k_39551160": "Confirmation box",
    "k_20c3663b": "Confirmation box configuration item",
    "k_293e7ce5": "Confirmation Box Title",
    "k_accc868": "Content of confirmation box",
    "k_40f69562": "Confirm button text",
    "k_d746b537": "Cancel button text",
    "k_8164a120": "Confirm callback function",
    "k_95eee7a9": "Cancel the callback function",
    "k_25e2291e": "Gets the specified component instance based on the ID (the return value is Vue instance)",
    "k_75206eff": "Component ID",
    "k_c2355592": "Gets an example of the page slice to which the specified component belongs",
    "k_1d4f7fac": "Component instance",
    "k_698205f2": "Introducing front-end common modules",
    "k_66af362d": "Module path",
    "k_37b003e2": "Reported",
    "k_676ffdd": "Reported data",
    "k_ebeb0203": "Event name",
    "k_824ce41f": "Element id",
    "k_4c6cedcc": "Get behavioral events",
    "k_f4804b8b": "Renderer Example",
    "k_901ce8d8": "Global LessCode instance",
    "k_18c54511": "Current page example",
    "k_bb65fe69": "Example of page slices on the current home page",
    "k_1ce4b236": "Mode",
    "k_fec0a056": "Current environment type",
    "k_5d87d036": "Current user",
    "k_bef7d5f": "User ID",
    "k_5e7c1fb9": "English name",
    "k_7500f155": "Chinese name",
    "k_85b228c6": "The section name",
    "k_5d9522b": "Organization name (slash/split)",
    "k_b42c7510": "Organization IDs (semicolon; split)",
    "k_8310207": "Avatar picture address",
    "k_cf39d58f": "Editorial identity",
    "k_8e1ed2c9": "Whether an administrator",
    "k_b71fa3b6": "Are signed in",
    "k_749a6a57": "List of roles",
    "k_b94ae843": "None in preview mode",
    "k_1de7d36d": "Role name",
    "k_aa5c52ce": "Permission entry",
    "k_9bf51032": "Permission item ID",
    "k_1380578c": "Page ID associated with the permission item",
    "k_67298115": "Role name associated with the permission entry",
    "k_80bfff5": "Center ID",
    "k_abbf5d6": "Group ID",
    "k_c8eec1a9": "Log out",
    "k_afd01e56": "Note: You will leave the current page",
    "k_afde2c92": "Switch accounts",
    "k_3fcb6f75": "Display the account switching floating window.\n\nYou can wait and get a boolean value indicating whether the user has performed a switching operation.",
    "k_f8cbcf73": "Do you want to refresh the page after switching? Default true",
    "k_d72c9a1": "Global custom events",
    "k_5c8b673a": "Platform preset events",
    "k_2ae35487": "Global Front Guard",
    "k_5769cb98": "Global postguard",
    "k_b35037a0": "Before page destruction",
    "k_93af025f": "Page destruction",
    "k_6f4c4660": "Page data source ready",
    "k_df4be9a1": "Page title modification",
    "k_282d5f6d": "Surveillance incident",
    "k_d709f01c": "Event name",
    "k_eadb18cc": "Event handler",
    "k_71716b0": "Listen for events (triggered only once)",
    "k_cc60abc1": "Cancel monitoring events",
    "k_949dce81": "Trigger event",
    "k_35a1ec73": "Event parameters",
    "k_d4725bd1": "Permissions",
    "k_26abe818": "Get a list of roles",
    "k_e879fbcb": "Get Role-User List",
    "k_cb0e8b54": "Optional, filtered according to business ID",
    "k_651210a5": "Optional, filtered based on role ID",
    "k_cba0e07e": "Optional, limited by user id or type",
    "k_a74c2567": "Get role-permission list",
    "k_5af39aee": "Role ID",
    "k_bb84828c": "Obtain role-related permissions and users",
    "k_fc86b69d": "Get a custom permission list",
    "k_9e4afe20": "Get a list of built-in permissions",
    "k_1bb1b1f9": "Get Interface-Permission List",
    "k_d4f0b53b": "New role",
    "k_1b18e8e9": "Role information",
    "k_f9b55d97": "Character English name",
    "k_ae615ff9": "Character's Chinese name",
    "k_8bb73dbc": "Type, which is generally an empty string. If it is a business type role, it is biz",
    "k_7488231a": "Update role",
    "k_8cf55902": "Only cname can be updated",
    "k_97bda7ed": "Remove roles",
    "k_a55875dd": "New permission",
    "k_2c97ec6a": "Authority information",
    "k_f2e2e311": "English name of authority",
    "k_b54458d1": "Permission Chinese name",
    "k_318dce62": "When the type is page, the page id can be associated, separated by commas",
    "k_8d54bf52": "Update privileges",
    "k_69dbd344": "Only cname and relatedPages can be updated",
    "k_29da5cbf": "Delete permission",
    "k_4e7e068b": "Add role members",
    "k_c4149bf5": "Role member information",
    "k_14314ec0": "User English name",
    "k_dee6b505": "Name",
    "k_2c818d6": "User type",
    "k_f65edbbd": "Business id, business isolation, required if the role is business type",
    "k_76762b9c": "Expiration time cutoff, ms",
    "k_9e9a70e2": "Delete role members",
    "k_8617382": "Role member record id",
    "k_177f55ae": "Add role permissions",
    "k_a72d6c1d": "Role permission information",
    "k_db13d6d4": "Page id, page related permissions are required",
    "k_3c1557fd": "Delete role permissions",
    "k_5b6015f2": "Role permission record id",
    "k_d8c8d661": "Batch delete role permissions",
    "k_b294b93f": "Role permission record id list",
    "k_d1f26184": "Add interface permission binding",
    "k_3345f8e2": "Interface permission binding information",
    "k_da3197fa": "Interface name",
    "k_25a152be": "Delete interface permission binding",
    "k_32b0e6c5": "Interface permission binding record id",
    "k_3964eb77": "Get a list of announcements",
    "k_e67e4b23": "Filter condition",
    "k_121a2081": "Refresh Announcement",
    "k_850ced59": "Watermark",
    "k_3fef3aec": "Display watermark",
    "k_5092fb0a": "Relevant flow sheet",
    "k_3ad57267": "Flowsheet ID",
    "k_425d0c81": "Approver",
    "k_92730769": "Process status node ID",
    "k_e7115459": "Process status node name",
    "k_90ac2ee": "Procedure status",
    "k_6ac42065": "Environment",
    "k_9dafa028": "Entity ID",
    "k_de407ccd": "Flow ID",
    "k_44d0bc15": "Obtain a separate process list",
    "k_e61b864": "Flowsheet type",
    "k_24745bd4": "Your filters",
    "k_e74d6eb8": "Get flow sheet details",
    "k_7e4ddb24": "Obtain process approval records",
    "k_6bbb26c1": "After process is initiated",
    "k_84f262e2": "Process Configuration ID",
    "k_ca9de38f": "Approval data",
    "k_294155ce": "Approval process",
    "k_182f935e": "Reinitiate the process",
    "k_9c38f466": "Cancellation process",
    "k_cd928a8e": "Whether the flow order is in progress",
    "k_b988962f": "Traveler",
    "k_f7f0ad7": "Can current users approve",
    "k_b3232aac": "Re-assign approvers",
    "k_9df2b850": "Approvers, multiple approvers are separated by English comma (,)",
    "k_56b8b199": "Application icon",
    "k_a119f596": "Current page information",
    "k_67c40419": "Main page information",
    "k_77b66f0b": "Get the current menu group",
    "k_15048c42": "Set the current menu group",
    "k_8802dca4": "Menu group name",
    "k_9f906f81": "Set the currently selected menu item",
    "k_bb362f85": "Multi-level menu item names",
    "k_79de9171": "Set the current menu closed/expanded state",
    "k_ff0e1c2f": "Whether to close the menu",
    "k_9780da86": "Get current menu data",
    "k_7807e7c8": "Get platform menu data",
    "k_ff8096c2": "Set menu data",
    "k_beead710": "Menu data",
    "k_33ee7983": "Get the current menu name",
    "k_b9d153c6": "Current domain name",
    "k_5d765ff6": "Current path",
    "k_48857b7c": "Route query parameters",
    "k_2bb38f4a": "Routing dynamic parameters",
    "k_cc53a57a": "Are Mini programs",
    "k_c58f67ec": "Whether the screen is narrow",
    "k_73226afd": "Screen size information",
    "k_37711124": "Prompt",
    "k_2e478339": "Success prompt",
    "k_b0104f9d": "Prompt content",
    "k_8106ac9f": "Warning prompt",
    "k_1b5acfe9": "Error prompt",
    "k_5d0d5ccd": "Loading Tips",
    "k_efad6913": "AI Assistant (This variable is an instance of the [openai-node](https://github.com/openai/openai-node) library new OpenAI(), the gpt-4o model is preferred)",
    "k_91e55be2": "Model name",
    "k_1f3bd4c": "Message list",
    "k_da545de1": "Role",
    "k_389afe34": "Content",
    "k_3444b160": "Whether to stream",
    "k_496f9183": "Behavior event",
    "k_f94021f4": "Pop-up message window",
    "k_6c21d053": "A confirmation box pops up",
    "k_180ccf54": "Display vertically centered",
    "k_c72881c6": "Icon",
    "k_f643e952": "Confirmed callback function",
    "k_27835c43": "Canceled callback function",
    "k_c3e01b2f": "Pop-up text input box",
    "k_87b97ef6": "Default input text",
    "k_34f51639": "Text type",
    "k_2b922dc5": "Allow empty strings",
    "k_4be19654": "Pop up a prompt",
    "k_fb99065f": "Duration",
    "k_6d00667a": "Pop-up notification box",
    "k_9cd43e7e": "Notification type",
    "k_e5235e35": "Position",
    "k_9adebda7": "Verification form",
    "k_4c9a311f": "Form object",
    "k_92596fa8": "Check error message",
    "k_a11a741b": "Call the LessCode method",
    "k_e2212c0c": "LessCode method name",
    "k_bd62d0a0": "Copy text",
    "k_81daa3b0": "Text",
    "k_5fcf4d2d": "Whether to pop up a copy success reminder",
    "k_85be1567": "Data source operations",
    "k_6e87ec70": "Data source ID",
    "k_baaf2048": "Data source method name",
    "k_59c09a5a": "Data source method input parameters",
    "k_557e6824": "Data source reinitialization",
    "k_3c39e538": "Upload to COS",
    "k_cd081a4c": "COS bucket ID (generally \"default\")",
    "k_de0484e8": "File content (string or Blob)",
    "k_e839028a": "Upload to path",
    "k_b3272cb3": "Multi-environment configuration (optional)",
    "k_a691eb9": "Upload header (optional)",
    "k_23373bc5": "File URL generated after upload",
    "k_6809e9d5": "Excel export",
    "k_50b570bc": "Export data",
    "k_350ec636": "Exported fields",
    "k_557187b6": "Field key",
    "k_e30c871a": "Field name",
    "k_760abed2": "File name",
    "k_42114a9f": "Sheet name",
    "k_b5de97d2": "Export format",
    "k_1f3cd2f4": "Excel import",
    "k_a1b1698d": "Parameters",
    "k_5cfef3e1": "Whether it is raw data",
    "k_cc449b3d": "Whether to output the date type as Date",
    "k_8f182987": "Character set",
    "k_5c776d11": "Extract file data",
    "k_1a587cd5": "Whether to choose multiple choices",
    "k_a630d32e": "Whether folders are supported",
    "k_a2c301ef": "Jump link",
    "k_812867e": "Link address",
    "k_26da58db": "Whether a new window opens",
    "k_2490874": "Return to the previous page",
    "k_ff216fbf": "Refresh page slice",
    "k_9b3199e4": "Scroll page",
    "k_5658bf6e": "Scroll position",
    "k_28098687": "Vertical Scroll Distance (px)",
    "k_dbe68ac8": "Component ID",
    "k_5b429f8b": "Component offset type",
    "k_f8b051f9": "Component offset distance (px)",
    "k_49f0e26": "Scrolling behavior",
    "k_29510c35": "Save Draft",
    "k_8ee067a1": "Draft namespace",
    "k_714bd626": "Whether to display confirmation pop-up window",
    "k_202752ab": "Restore draft",
    "k_5fce6fb0": "Whether to keep the draft after cancellation",
    "k_895cadaf": "Delete draft",
    "k_c5052b21": "Email notification",
    "k_3a3856d5": "Recipient mailbox",
    "k_7ba688d4": "CC to email",
    "k_e996f2ec": "Secret email address",
    "k_80755700": "Subject line of your email",
    "k_d8bbcc26": "Mail content",
    "k_6a73fffe": "Enterprise Micro Robot Notice",
    "k_78442bab": "Robot ID",
    "k_d4c387bd": "Notification content",
    "k_871a2b73": "Whether a success reminder pops up",
    "k_76deb9d2": "Enterprise WeChat Notice",
    "k_26dfe8b8": "Receiver, multiple recipients are separated by English comma (,)",
    "k_9dcb759a": "Notice Title",
    "k_c578bff5": "Notification describes",
    "k_91d67a50": "Notifications link",
    "k_99a738b7": "Notification button text",
    "k_6ebe5600": "Arouse corporate WeChat",
    "k_ecf43a43": "Send GPT message",
    "k_550f765b": "System preset Prompt",
    "k_f81c9678": "Message content",
    "k_2da7ea70": "Return message form",
    "k_1013fb89": "JSON string",
    "k_85bf7666": "Calling method",
    "k_976bc490": "Language model",
    "k_e69faad7": "Interface",
    "k_ae6ce5a2": "Set",
    "k_933f0a92": "Generally used to set UI visibility",
    "k_1ffa8b76": "You can set associated pages, page-level permissions, belonging to \"page permissions\"",
    "k_322729b3": "You can bind the data source interface, and the user must have this permission after binding; you can also use it as an application-level permission without binding the interface",
    "k_4fb28b71": "You can set the authority collection represented by this authority to facilitate empowerment",
    "k_3791ae81": "View page data",
    "k_a4177c8b": "New page data",
    "k_c29b268d": "Update page data",
    "k_72717946": "Delete page data",
    "k_9ff81031": "Upload",
    "k_7aca5db4": "Views",
    "k_3309ee44": "To view page data, you can call the data source interface on the corresponding page: get/list/count/request/custom_*",
    "k_c5039f5e": "Inheriting built-in permissions: View application data",
    "k_57aa613f": "New",
    "k_8239358a": "To create new page data, you can call the data source interface: create on the corresponding page",
    "k_a425d297": "Inheriting built-in permissions: Create new application data",
    "k_d635ddcf": "Update",
    "k_af997d55": "To update page data, you can call the data source interface: update on the corresponding page",
    "k_507dc197": "Inheriting built-in permissions: Update application data",
    "k_62ace18c": "Delete",
    "k_8d6926d8": "To delete page data, you can call the data source interface: delete on the corresponding page",
    "k_e929a11f": "Inheriting built-in permissions: Delete application data",
    "k_b4ab8820": "You can use the upload component on the page",
    "k_d296cf84": "Inheriting built-in permissions: Upload application data",
    "k_4bca5fce": "This deployment version does not support obtaining department information",
    "k_20eab0f4": "Failed to obtain cloud function list",
    "k_f17674e8": "Failed to obtain data source interface",
    "k_f93a65e": "Failed to obtain role user list",
    "k_bc39f142": "Failed to obtain role list",
    "k_91736e1b": "Do not have permission to view the current environment permission configuration",
    "k_e207c2bf": "It is suspected that the corresponding environment has not been released. Please send the version first and visit again.",
    "k_48228147": "Method",
    "k_ca5af18d": "Global instance/Global LessCode instance",
    "k_4e2e12ab": "Operation",
    "k_a595254": "Please choose...",
    "k_f4821e1e": "This data source does not support Action",
    "k_5e8608ce": "Cannot find behavior atom with id={arg_0}",
    "k_ab346fdc": "Pop-up window",
    "k_3b946cbd": "Please don't tell others.",
    "k_dc969d37": "Initialization",
    "k_2cda9ec3": "The data source may not be ready yet, ** cannot call the data source method **",
    "k_81ab3892": "Rendering is complete",
    "k_260b0ada": "The page rendering is completed",
    "k_f2f7a633": "Current page renderer instance",
    "k_4b0e58ee": "Data source ready",
    "k_be520a20": "The data source method can now be called. If the data source has the configuration of \"automatically pulling data when opening the page\", it will wait for the pulling to complete before executing the logic here",
    "k_503bf855": "Destruction",
    "k_73174ea2": "[Title] Please place components",
    "k_264a81e2": "[Content] Please place component",
    "k_a894f1": "[Footer] Please place component",
    "k_6de62429": "Attribute",
    "k_86587150": "Type shown",
    "k_3b38ba37": "Appearance",
    "k_19344599": "Drawer",
    "k_55534ba": "Mobile adaptation",
    "k_7bc6ba9c": "Direction of drawer",
    "k_57e47023": "On",
    "k_f7146b42": "Right",
    "k_34d6ee68": "Under",
    "k_71407e53": "Left",
    "k_6b927d0f": "Width",
    "k_c8f018b2": "Height",
    "k_801a9847": "Display the title",
    "k_6a4f4221": "Display footer",
    "k_cb14571a": "Custom title",
    "k_80ff7ac4": "Display the close button in the upper right corner",
    "k_a1567091": "Function",
    "k_23cfb0c": "Display mask",
    "k_850dcf5e": "Support Click on Meng Layer to close",
    "k_9a79a966": "Support keyboard ESC shutdown",
    "k_ba401173": "Keep instances when shutdown",
    "k_92eb515a": "Shutdown parameters",
    "k_efc8842c": "Default return parameters when ESC is closed via the close button in the upper right corner/click on the mask/keyboard",
    "k_d9afd55b": "Modifying {arg_0} id requires manual updating of LessCode and associated component configurations ",
    "k_6b5c498e": "{arg_0} Name",
    "k_60c13d1": "{arg_0} Description",
    "k_ef2752f1": "Please enter a description",
    "k_71396bdf": "{arg_0}{arg_1} cannot be empty",
    "k_7f9d6de2": "{arg_0}{arg_1} already exists",
    "k_9958d541": "ID consists of letters, numbers, underscores, and dotted lines, and can only start with a letter",
    "k_aabed947": "System components",
    "k_36c295fe": "Open",
    "k_2aa9a982": "Note: Do not call data source methods at this time",
    "k_10c72f14": "Closed",
    "k_37ecd1c1": "Pop-up window container",
    "k_fd5813cc": "Reset footer",
    "k_7769c024": "Data loading, please wait...",
    "k_50ad3252": "Please select a page (slice)",
    "k_ebf6f6f1": "The page ( {arg_0} ) does not exist or does not have permission to access. Please contact the application administrator ",
    "k_632fca9c": "Page (slice)",
    "k_b1b44774": "Page slices in the current page",
    "k_a792bd21": "Process node",
    "k_1c84afdb": "Processes and nodes",
    "k_a2c2ad0": "Parameters (page/page in-chip parameters are obtained through props.xxx)",
    "k_392ee8e0": "Load mode",
    "k_4351ea3": "Default mode displays loaded copy and progress bar",
    "k_5c568e48": "Space-occupying",
    "k_ba47627b": "Silence",
    "k_a3aeb4a1": "Navigation",
    "k_dee04081": "Page header",
    "k_aa3fe1fb": "Footer",
    "k_c0c196cd": "Navigation-Menu-Content",
    "k_902c005": "Navigation-Content",
    "k_c27629db": "Menu-Content",
    "k_95061ec5": "Following the application",
    "k_a6cf7a31": "Fixed",
    "k_ea62011c": "Not fixed",
    "k_175cf024": "Open",
    "k_e11996e1": "This is not the page that initiates the process",
    "k_f032e031": "Read-only",
    "k_870f9752": "Can be used to distinguish whether it is the current [Initiation Process Page] or the [Process Information View Page]",
    "k_37063e8": "Use the data in the form to initiate the process",
    "k_db6c4c30": "Do you want to skip to the process details page immediately",
    "k_a94f29e9": "Including { id, url } are the process order ID and process order page address respectively.",
    "k_36f32f78": "Flowsheet page address",
    "k_3a4f696d": "Process initiation time",
    "k_b95f29cd": "Please fill in the complete information as required",
    "k_c57b3af3": "Approval results",
    "k_60dfbbf6": "Additional data",
    "k_e012233a": "Whether it can be approved",
    "k_12abbf4b": "Approval status",
    "k_b6b37fe9": "Not entered",
    "k_2b33f3b1": "Has agreed",
    "k_ac340aed": "Has rejected",
    "k_e6a258": "First entry time of the approval node",
    "k_2c39d011": "Refused",
    "k_10a76eb6": "Approval records",
    "k_e4ccef54": "Approval time",
    "k_af5414b": "Approval operation",
    "k_44114cee": "Approval operation name (Chinese)",
    "k_a0bb7c10": "Approval of additional data",
    "k_4243429f": "Whether the approver can be modified",
    "k_9cf35c5a": "Modifying approvers",
    "k_3b808133": "Can it be withdrawn?",
    "k_7a3ed5e8": "Processing approval",
    "k_c9bca75c": "Use the currently filled approval comments, additional data, and then agree or reject the approval",
    "k_19a8b499": "Operation type (approve or reject)",
    "k_99affa7": "Approval form information",
    "k_21748b59": "Whether to refresh the page",
    "k_c00080d7": "Modification Approver",
    "k_bf64b307": "Withdraw approval form",
    "k_c7094d70": "Revocation reason",
    "k_8bf01828": "Save Changes",
    "k_a19e528c": "Please enter approval opinions",
    "k_5d6cef6d": "Approval initiation time",
    "k_79195c86": "Please enter reason for withdrawal",
    "k_1f0337f5": "{{ data.item.operation === \"request-cancel\" ? \"Reason for withdrawal\" : \"Approval Opinions\" }}",
    "k_20f9ed2e": "{{data.item.comment ||'None'}}",
    "k_c1f8f987": "New approver",
    "k_c3d4b23f": "Data.item.operationName ||\"Unknown operation\"",
    "k_2b61ef35": "By",
    "k_bc41aa0e": "Approval failed: {arg_0}",
    "k_fa1e03eb": "Approval Form",
    "k_62e39ed6": "Approval information",
    "k_9dab0db4": "Node title",
    "k_a2720945": "The content output",
    "k_81281655": "Whether implemented",
    "k_eeabe100": "Whether it is runtime",
    "k_fe9d08d4": "Execution time",
    "k_36817ece": "Unable to load this node",
    "k_3a2c8442": "Which process",
    "k_eeed722a": "Which node",
    "k_94e14a60": "Inserted",
    "k_9a3e572d": "Trigger refresh method",
    "k_a6129a05": "Preset event A",
    "k_aaef185b": "Trigger the execution of this event through the behavior of 'Trigger Page Slice Event'",
    "k_3e0ae0c8": "Custom parameters for triggering event behavior",
    "k_e5868a4d": "Preset Event B",
    "k_81dc7095": "Preset event C",
    "k_7a3fc12a": "Preset event D",
    "k_8d6b2f84": "Preset event E",
    "k_288dd50f": "Embedded page (slice)",
    "k_e621cb4b": "Please place the component",
    "k_96601653": "Combination",
    "k_6cf6f169": "Navigation bar",
    "k_d9dfdfe7": "Menu bar",
    "k_de3f6751": "All rights reserved by Tencent",
    "k_d8a2afad": "Wuji",
    "k_bf9fc2a5": "Preset footer",
    "k_2b7a061a": "Please select a page slice",
    "k_ac6619e7": "Page slice parameters (page slice parameters are obtained through props.xxx)",
    "k_db697003": "It is executed when preset event A is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_aa5b7ad3": "It is executed when preset event B is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_f1f83a1c": "Pre-set event C is executed when triggered. Event parameters XXX can be obtained through `$event.XXX`",
    "k_2ce9658c": "It is executed when preset event D is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_7d857536": "It is executed when preset event E is triggered. You can get event parameters XXX through `$event.XXX`",
    "k_12934ef": "Embedded page slice",
    "k_f4be42a8": "Upgrade components",
    "k_5559df05": "Main page",
    "k_d9f05628": "Data",
    "k_81f9b3dd": "Layout",
    "k_c128db0a": "[UICore Component]: Invalid custom material panel configuration",
    "k_8f4590e6": "UICore container",
    "k_f52c3a97": "Page content",
    "k_f6038854": "Design patterns",
    "k_6aba996d": "Rendering mode",
    "k_c21674c2": "Data pattern",
    "k_28ab348e": "The bound data will be mounted to the internal state.data",
    "k_7f45c7cf": "Incoming data",
    "k_4c62c755": "Transparent data source",
    "k_89d9f612": "Default container type",
    "k_5680f367": "Default root container for layout",
    "k_96ea028e": "Customize Materials Panel",
    "k_fe5d7e71": "[Help Document]({arg_0})",
    "k_d24e613c": "The palette",
    "k_d917a44c": "Editor UI pruning",
    "k_aeeea430": "Data source panel",
    "k_44699d07": "Styles panel",
    "k_552adbfc": "Action panel",
    "k_f0677e86": "Toolbar",
    "k_cfc697e9": "Cannot find the corresponding pop-up window for [{arg_0}]",
    "k_11b924b2": "Directional icon",
    "k_513aa36a": "Edit class icon",
    "k_750c2d01": "Data type icon",
    "k_1b5eddd1": "Common website icons",
    "k_ab381309": "Prompt Suggestion icon",
    "k_e40ed065": "[wuji-lang] Non-existent language key:{arg_0}, optional language {arg_1}",
    "k_3a29b68c": "The Infinity AI module is not loaded. Please open the Infinity AI plug-in on the editor end or execute await w.ai.init() first to initialize the module.",
    "k_bbda484b": "This deployment version does not support switching accounts. Please contact the platform operation and maintenance personnel",
    "k_e73d3008": "The function of switching accounts is only available under the product terminal (custom domain name)",
    "k_80c752be": "Global pop-up window {arg_0} does not exist",
    "k_23bee451": "Application LessCode execution failed. Please verify the application-level LessCode code",
    "k_7139e139": "Current page LessCode",
    "k_e05c0285": "Pop-up window on current page",
    "k_154aa5b9": "Global pop-up window",
    "k_65c2fdc0": "Configured",
    "k_83e17e05": "Bidirectionally binding data",
    "k_decbb89d": "Binding to {arg_0} ",
    "k_489945db": "Unbind",
    "k_9f832f79": "Add two-way binding",
    "k_603cb18b": "Add parameters",
    "k_eb0f4b57": "Please write the body in json format (if you use an interpolation expression, the interpolation expression also needs to be enclosed in double quotes)",
    "k_fd6b6f49": "Add headers",
    "k_67043122": "Add Query",
    "k_6e73fc8f": "No robot, click to go",
    "k_8eacc445": "Failed to get list",
    "k_583e411e": "No email configuration, click Go",
    "k_9b4915e5": "Query (url parameter)",
    "k_9427ddac": "Body (post package)",
    "k_e4bdf11d": "Please enter an object in JSON format",
    "k_5b9033fd": "If you want dynamic binding, use the {{}} symbol, eg: {{ state.foobar }}",
    "k_69356f85": "Return value",
    "k_b07e9f5": "Output structure",
    "k_43e92019": "The return value of this method is returned by a custom method",
    "k_c616c3ad": "View custom codes",
    "k_fd4399af": "Method has no return value",
    "k_8d797f41": "No parameter is passed",
    "k_65872b47": "Using default parameters",
    "k_25102dfb": "Form parameter transfer",
    "k_9d00e138": "Javascript parameter transfer",
    "k_7625a65": "Edit the method",
    "k_3d701ed4": "Data source method",
    "k_90ea79d8": "If you want to customize parameters, you can switch to [Form Parameter Transfer] or [javascript Parameter Transfer] for configuration.",
    "k_fd71b054": "* For querying data, the parameters are relatively fixed, so [Form Parameter Transfer] is recommended.",
    "k_a4bb75d7": "*\n        The calls or parameters of interfaces such as create/update are relatively complex, so it is recommended to [javascript parameter passing]",
    "k_c0d077c3": "Which data sources",
    "k_40e12257": "Which {arg_0}",
    "k_26612844": "Enterprise WeChat name",
    "k_43c1ae41": "Robot documentation and internal customer service documentation",
    "k_237bc811": "Enterprise WeChat Personal (Fixed)",
    "k_b70356ce": "Enterprise WeChat Personal (Dynamic)",
    "k_987248f2": "Enterprise WeChat customer service",
    "k_c1932a78": "Listing",
    "k_f7e40879": "Fetch field",
    "k_b73f2f71": "Support nested values eg: a.b ;a[0].b",
    "k_f7a26bdd": "Column width",
    "k_dccc0fc8": "Enter the number of characters to display",
    "k_8cc381d1": "Drag to adjust the order",
    "k_54fd5dc4": "Unable to find the corresponding DataStub through [{arg_0}]",
    "k_61530082": "Whether to overwrite existing field structures",
    "k_e8799b7b": "No valid fields found",
    "k_a8439897": "Select the exported data structure",
    "k_29363163": "Failed to obtain cos list",
    "k_26919dd0": "Launched",
    "k_56794467": "COS barrel",
    "k_d4841c80": "Failed to obtain environment",
    "k_11f702ca": "Failed to obtain cos bucket",
    "k_89f8ab26": "Whether to also use the data of [{arg_0}] as data exported by Excel",
    "k_1676d8d9": "Use",
    "k_900b3b73": "Not use",
    "k_a9045ace": "Click here to view how to use it",
    "k_780873c9": "Derived modes",
    "k_c999103a": "Single worksheet",
    "k_66ac1296": "Multiple worksheet",
    "k_6eb123be": "Data derived",
    "k_ca1c0520": "1. Use the page variable eg: data.yourSource.listData \n2. Use the execution result of the previous process eg: flowState.res.listData",
    "k_dc583a10": "Export field configuration",
    "k_360626d4": "Configuration Mode (Fixed Column)",
    "k_1abb08d4": "Code pattern (dynamic column)",
    "k_8e398123": "Using template parameters",
    "k_638a8aa2": "Calculate exported table configuration",
    "k_2a4f2a": "Table name",
    "k_1faa8471": "Supported formats",
    "k_fbdfa0eb": "Do not destroy when closed",
    "k_5f572fdd": "Instance ID",
    "k_e9412c3b": "This id is used to distinguish instances when opening multiple global pop-up instances that are not destroyed",
    "k_9a34c9f8": "UI interaction",
    "k_de5ea61d": "Logic",
    "k_d099f7e5": "Import and export",
    "k_3f834a96": "Page navigation",
    "k_1fbf2138": "Draft",
    "k_ba87aead": "External notification",
    "k_d379411b": "Flow",
    "k_435ec665": "AI behavior",
    "k_afd3dc81": "Return parameters (received in the pop-up action)",
    "k_befd930": "Copywriting",
    "k_bbd635d2": "Please set up a copy",
    "k_42b5bcb3": "No icon",
    "k_685d6a2f": "Width (optional)",
    "k_c1edc7b3": "Example: 300px",
    "k_ce9aec82": "Copywriting (support HTML)",
    "k_5f65a3f5": "Do you really need to perform the operation?",
    "k_a6c10c8b": "Select \"No\" to terminate the process",
    "k_3e4288c8": "OK button text",
    "k_4bbade06": "Cancel button text",
    "k_cac6d06c": "User confirmation results",
    "k_6ef1fc66": "Prompt type",
    "k_f333bb56": "Prompt duration",
    "k_bd1ae025": "Whether it is a synchronization prompt",
    "k_38a16ad0": "Please set content",
    "k_bea8f01c": "Ejected position",
    "k_aa249141": "Top left",
    "k_e4aaa5f4": "Top right",
    "k_7a343db": "Bottom left",
    "k_dd02512": "Lower right",
    "k_9e4338a9": "Please set the notification content",
    "k_87d39ce8": "Prompt message",
    "k_3c44cecd": "Please enter something:",
    "k_af6b478e": "Default value",
    "k_edbc9275": "Cryptographic pattern",
    "k_e701eb7": "Input box mode",
    "k_1a11e9f0": "Single line of text",
    "k_6f01c427": "Multiline text",
    "k_37e04981": "Password",
    "k_ae19ffdb": "Terminate the process if \"Cancel\" is selected (otherwise the default value will be used)",
    "k_66fbceac": "User-entered text",
    "k_f0f0b2d1": "After the pop-up window is closed, perform the next steps",
    "k_7635550a": "Select pop-up window",
    "k_974ae2ed": "Global pop-up settings",
    "k_31bc6f57": "Pop-up window parameters (parameters in the pop-up window can be obtained through props.xxx)",
    "k_72f37eba": "Return value of pop-up window closing behavior",
    "k_574502d4": "Please press the keyboard",
    "k_c7032f1f": "To paste content",
    "k_9a95596f": "Unpaste",
    "k_ece20544": "Trigger page slice event",
    "k_4fd51ad": "Externally you can get the event parameters XXX given here through `$event.XXX`",
    "k_46887ac9": "Trigger event name",
    "k_839a3e2f": "Selection event",
    "k_2314c3dd": "Trigger page slice event [pagelet:emitEvent]: Event must be selected",
    "k_58db280b": "Three-way merger",
    "k_42e604ca": "The content of the two versions can be compared and merged based on the benchmark version",
    "k_6b5c77c2": "Reference content",
    "k_887aea61": "Remote content",
    "k_6bb4aebe": "Current content",
    "k_94679553": "Prompt for merge results",
    "k_c5e8c73f": "The result of the merger",
    "k_6c34fb11": "Merge failed {arg_0}",
    "k_b6c7cd42": "Copy content",
    "k_ab2f9455": "Whether to prompt for successful replication",
    "k_5d7546c9": "Replicate successful",
    "k_c4527cc7": "Call the LessCode method",
    "k_45a18c6d": "Supports the called method of async. Wait until completion before performing subsequent steps.",
    "k_1072df58": "Method name",
    "k_64abe122": "Terminates the process if the method returns false",
    "k_ea8c405b": "If you need to use variables or expressions, use double curly braces",
    "k_693e92c8": "Return result of the called function",
    "k_fcb8d24": "{arg_0} method not found",
    "k_f9ea362d": "Some debugging information of the current step will be output on the Console, and you need to cooperate with the browser DevTools to view it.",
    "k_c61eae6d": "Online components send events",
    "k_8742c1ac": "Throw events from this online component",
    "k_860cb6b9": "Event Key",
    "k_ae5b82aa": "The return value here is passed as an event parameter to the page that uses this online component",
    "k_dc1c76e2": "Parameter description",
    "k_6c9fc5ff": "Whether to prompt the user",
    "k_50dc0493": "Specified namespace",
    "k_ee418e6d": "Used when business needs to be differentiated. When not specified, the draft will be used on the current page or pop-up window by default",
    "k_88c23b2": "Do you want to save the current draft?",
    "k_82f82611": "Save",
    "k_afe8015f": "Whether to keep the draft after the user cancels the recovery of the draft",
    "k_53418628": "Do you want to restore the last edit?",
    "k_e6309c92": "Recovery",
    "k_80a14618": "If you specify a namespace for saving the draft, you need to enter the corresponding namespace",
    "k_27471e41": "Call the data source interface",
    "k_5f44e25a": "Call the data source interface and return the interface call result. Batch calls are supported (note that this step will not update page data)",
    "k_ec3d9266": "[Call data source interface]{arg_0} interface cannot be found",
    "k_cfb09baa": "[Data Source Request] parse db body fail",
    "k_2cc69474": "Return to inclusion",
    "k_91e5dde9": "Error object (if any)",
    "k_f3e9a9be": "Batch call data source interfaces",
    "k_abae125": "Calling the data source interface in batches and returning the interface call result is different from the front-end batch in 'Calling Data Source Interface', where the batch here is the back-end batch of a single interface. Currently only DB data sources support this operation",
    "k_3f9f0029": "Which data source, value format: data. {sourceId}.$ methods, where sourceId must be obtained through the Information command",
    "k_cd45b1ee": "The method ID of the data source is obtained through the Information command.",
    "k_33c44e2a": "Data source {arg_0} does not exist",
    "k_c25685da": "Data source {arg_0} has no method named {arg_1}",
    "k_1e5940c0": "This behavior calls the initialization (init) methods of all data sources in batches concurrently",
    "k_2f3b9d5c": "CosID{arg_0} does not exist",
    "k_c4d0427b": "Failed to obtain cos authentication: {arg_0}",
    "k_e1e78fd4": "Failed to initialize cos instance",
    "k_2c94375e": "Unknown error",
    "k_a118cf2e": "Export failed: {arg_0}",
    "k_9f36607a": "Support export of files in xlsx, xlsm, csv (single sheet) formats",
    "k_e9e9695c": "Configuration mode",
    "k_e1e11a10": "Field configuration",
    "k_b5f10368": "Dynamic field configuration",
    "k_fb41e1e5": "The csv format does not support multiple sheet export",
    "k_4aa39d46": "Exported successfully",
    "k_a969fe1b": "[excel export] The target data is not an array",
    "k_1dfb1e37": "[excel export] Invalid field configuration",
    "k_efdf84fc": "[excel export]{arg_0}",
    "k_70ddc8ae": "Next steps can be accessed through `flowState.__ file__`Gets the imported file object",
    "k_6cb362be": "Raw data",
    "k_69bc32": "Output date type as Date",
    "k_2867ff28": "Current sheet data",
    "k_f26bf591": "Current row data",
    "k_c1d887b4": "Data imported by excel",
    "k_e91893f3": "Only support extracting text file data\nSuch as JSON/CSV/SQL/plain text files",
    "k_f314d0fa": "Whether multiple selection is supported",
    "k_3fd339bd": "Whether to support selecting folders",
    "k_ebf018c5": "Not support the file type",
    "k_6672f6bd": "File extraction error {arg_0}",
    "k_84e12d81": "File data",
    "k_df697691": "File object",
    "k_782e51cb": "Multi-environment configuration (this is not required if you do not need to distinguish between environments)",
    "k_48792209": "File",
    "k_bd7bc3be": "Upload path",
    "k_6ae4af4e": "Upload header",
    "k_2f3fb26f": "The header key needs to be in standard writing, such as Content-Type",
    "k_f3907866": "Upload file path",
    "k_a92d86c2": "Upload to COS failed, invalid file or COS bucket configuration",
    "k_78c19cee": "Scroll failed, component for {arg_0} could not be found",
    "k_decc77b1": "Top",
    "k_8c958f15": "Bottom",
    "k_a66cb0f": "Specified location",
    "k_89a11799": "Specified component",
    "k_a260363d": "Vertical axis position (unit: px)",
    "k_69a21bd8": "Component offset value (unit: px)",
    "k_778f580d": "Instantly",
    "k_159b7cfb": "Smooth",
    "k_d0db6d9e": "Page query parameters",
    "k_baf5a140": "Page params parameter (replaces dynamic parameters in page path)",
    "k_dee8fec5": "New window opens",
    "k_8152a789": "Jump method",
    "k_bbdb1e32": "Push (history adds new record)",
    "k_232e5437": "Replace (history does not add new records)",
    "k_537ce862": "Jump failed, invalid page path",
    "k_bdbf6cfb": "Open: {arg_0}",
    "k_c9de7c76": "Invalid jump link",
    "k_5c296f05": "Whether to return to the previous page",
    "k_8298cc2b": "Email delivery failed",
    "k_991ce1c6": "Enterprise WeChat notification failed",
    "k_8776aed9": "Sender",
    "k_87c972c2": "Recipient",
    "k_6b4bdb44": "CC",
    "k_b4a66fa3": "BCC",
    "k_88ba6118": "Message subject",
    "k_ce65f7d": "Recipient, subject or content is empty, please check",
    "k_24609626": "For more information on the message format, please [click to view](https://developer.work.weixin.qq.com/document/path/95274)",
    "k_74aa8f66": "Robot",
    "k_27231ac8": "Message",
    "k_d668b27": "Success notification",
    "k_992d2e52": "Robot notification configuration error",
    "k_b2c30c5e": "Robot messages should be valid JSON",
    "k_130d0afe": "Robot notification was successful",
    "k_d6c2487a": "Robot notification failed",
    "k_7c7b63c2": "Notification settings",
    "k_c87204a1": "Notification application (message sender)",
    "k_cd6d0115": "Message recipient type",
    "k_7fef35c1": "Message recipient",
    "k_30075892": "Message type",
    "k_e9edcb6b": "Link",
    "k_4e9ddf9c": "Button text",
    "k_25b5db1": "Details",
    "k_1ddf7efa": "Enterprise WeChat notification-Message recipient cannot be blank",
    "k_6e6ce56f": "Enterprise WeChat notification-text content cannot be blank",
    "k_64cd4e72": "Enterprise WeChat notification-Markdown content cannot be blank",
    "k_bcb0cb20": "Enterprise WeChat notification-text card message configuration is incorrect",
    "k_7e3d2d55": "Enterprise WeChat notification was successful",
    "k_c85e61eb": "Arouse configuration",
    "k_78c9f6ed": "Enterprise WeChat name (dynamic)",
    "k_262dd001": "Customer Service Number (uin)",
    "k_c0a669ff": "Enterprise WeChat name cannot be blank",
    "k_5637b420": "Enterprise WeChat customer service account cannot be empty",
    "k_49ef6584": "Invalid data id created",
    "k_f092c6f1": "No corresponding e-flow configuration found",
    "k_8ac9756d": "Refresh data",
    "k_7e337e20": "(Old version) Repulling data from the data source",
    "k_4ee37630": "(Old version) Submit changes to the data source",
    "k_cab25464": "Behavior type",
    "k_cb7b2f5f": "Automatic (create/update)",
    "k_9307b9ba": "[Single Mode] Create",
    "k_9ecfbaa8": "[Single Mode] Update",
    "k_99303c22": "[Single Mode] Delete",
    "k_ac1b0a9d": "[List Mode] Update list",
    "k_4cbd990b": "After the operation is complete, reload the form data",
    "k_9f967bfb": "Operation failed: (Error code {arg_0}){arg_1}",
    "k_35beaf82": "Operation failed",
    "k_887aff3f": "Data source operation results (in creation mode, objects of the type { \"id\": xxxx })",
    "k_8660c77a": "(Ancient version) Approval rejected",
    "k_7737216e": "(Ancient Version) Approval",
    "k_5628bc7e": "(Ancient Version) Launch Process",
    "k_2c3ea8e7": "New object ID",
    "k_7c8c3d01": "Approval (Obsolete)",
    "k_46b126e8": "Process instance ID",
    "k_9e304f99": "Current state",
    "k_9ab62ea7": "Process instance ID cannot be empty",
    "k_c38db77e": "Approval failed {arg_0}",
    "k_4a3f0b62": "Approval rejected (scrapped)",
    "k_f14ee314": "Send HTTP requests",
    "k_94c37ee5": "* All of the above input boxes support filling in interpolation expressions",
    "k_70f6fcda": "Request method",
    "k_df74607c": "Request whether to bring cookies",
    "k_8449f277": "Timeout (milliseconds)",
    "k_9f485e2d": "Prompt copy of request failure",
    "k_bf5703b2": "Request response results",
    "k_5c48d2f7": "Request failed {arg_0}",
    "k_a845563c": "Data source operation (deprecation)",
    "k_58ebfdb1": "Reset the form",
    "k_93aee2cc": "Submit list modification",
    "k_8625c190": "(Automatic) Create or modify current data",
    "k_6cbc4fd6": "New data",
    "k_8e27d1ed": "Modify current data",
    "k_5ae844c5": "Delete current data",
    "k_801f8b43": "Data source {arg_0} failed to load data: {arg_1}",
    "k_ed220acd": "Data source {arg_0} failed to load data:",
    "k_3d73abd4": "Submitted",
    "k_b28b8591": "Modification submitted",
    "k_def1fbf": "Are you sure you want to delete it?",
    "k_bcc32046": "Deleted",
    "k_c82fad7a": "[Delete] button",
    "k_cf253b2f": "[Submit Modification] button",
    "k_7e50dcc4": "The data source {arg_0} is configured with pageCon.filter, as well as filterCon. The former has been abandoned",
    "k_444430e0": "Currently not in edit mode, please check the program",
    "k_6d1284ad": "[Error initializing data source {arg_0}]{arg_1}",
    "k_3c2fcf6c": "[Error initializing data source {arg_0}]",
    "k_3ba8c339": "Initiation request",
    "k_b88cbc7c": "{arg_0} Request",
    "k_b81f65d4": "Complete form",
    "k_a825e869": "Create mode",
    "k_b908ebdc": "Edit mode",
    "k_b4e0eda3": "Create",
    "k_bd3502a1": "Regular expression for mismatch fields: {arg_0}",
    "k_f0c187da": "Please use the Component Library Panel-Data Source to find the fields you need",
    "k_2fdfb965": "Manage data sources",
    "k_c7617bee": "Add a data source",
    "k_713188c6": "Import fields from a data source...",
    "k_fd7bb4ad": "Currently, there is something in your form, and switching data sources will lose the original content. Continue?",
    "k_ba7bcc9e": "This data source cannot be imported. Please drag and drop the \"Data Source\" on the left to create a form.",
    "k_ffd990d6": "To create a form, add a data source first",
    "k_7b73f217": "Please select a data source to generate the form?",
    "k_2a94f0a7": "Use a blank form",
    "k_cfa7b86c": "The operation failed. The form cannot be generated for {arg_0}. Please contact the platform for feedback.",
    "k_60f12616": "Form",
    "k_aaa749fd": "Data field",
    "k_fca2d25": "This component is recommended based on the data table structure",
    "k_9458a089": "Read-only field, please bind data",
    "k_186d0aa9": "Title The Title",
    "k_ded80341": "Subtitles can be deleted if not needed",
    "k_2c802746": "Here are some introductory words... Please note modification, or bind to existing fields of the data item",
    "k_ba316f4": "Additional copy can be deleted if you don't need it.",
    "k_9a72f433": "A button",
    "k_b851c33e": "Button 1",
    "k_439f1dde": "Button 2",
    "k_9c6b12b8": "Detail card",
    "k_c168c0d4": "Picture card",
    "k_faa2c640": "List card",
    "k_738e8fff": "Data source log",
    "k_474fe315": "Data source operations (old version)",
    "k_60a43bda": "Form type",
    "k_f3ce8893": "Labeled form",
    "k_2dea198d": "The tagged",
    "k_941fcdcf": "Bidirectionally binding",
    "k_83c6125f": "Please define $query in the Data Source-> URL parameter. {arg_0} and turn on bidirectional binding to modify query",
    "k_1e47e304": "URL parameter",
    "k_2b1ce2d3": "Data source dependence",
    "k_99bd28": "Simulated routing dynamic parameters",
    "k_81d9c287": "Parameters passed to pop-up window",
    "k_5069894a": "Parameters passed to page slices",
    "k_5a2afe32": "Extension list",
    "k_7a08a84e": "Extension list floating layer",
    "k_44f6a314": "Disable",
    "k_17b4aaa": "Enabled",
    "k_9b3c9d10": "Full-app",
    "k_5e1c73ec": "Current page",
    "k_77b6dbe7": "Do you want to enable it for all applications or only on the current page?",
    "k_db74c191": "There are no extensions yet~",
    "k_58e5482a": "[Refresh Process] button",
    "k_b1f3c5de": "System built-in",
    "k_4fe45eb8": "Current process",
    "k_e7c729c4": "Flowsheet title",
    "k_4fd3370b": "State",
    "k_d504e954": "Initiation-time parameters",
    "k_a3f12f59": "Global variables",
    "k_8d3c0d1f": "Data for each node",
    "k_7a43682c": "Process status description",
    "k_14e01ff1": "Current approver",
    "k_fa394825": "Pay close attention to people",
    "k_53ed26e4": "Flowsheet website",
    "k_8e55351a": "Block of process page",
    "k_f40ef4e7": "Block header",
    "k_47fb1a2c": "Time",
    "k_63052eef": "Corresponding step node ID",
    "k_d583610a": "Corresponding step node type",
    "k_66b0b5ef": "Refresh page data",
    "k_afb8249": "Waiting for the next area",
    "k_196b77f3": "Block loading failed:",
    "k_3d32069c": "Place the form here",
    "k_15412cc9": "Page slices of process nodes",
    "k_445595f6": "To configure the page, please operate directly on the left",
    "k_cabed2d9": "To configure data source events, please use the top [Behavior] panel",
    "k_ccfb4c84": "This is the default block",
    "k_ed512d02": "Break it up for editing",
    "k_b08b118a": "Note: After breaking up, if you add new parameters during process design, there will not be automatic synchronization here!",
    "k_5d715b44": "Default page slice content",
    "k_e1afd816": "This whole is the default form block and is automatically generated based on process configuration",
    "k_d3f3f7d8": "If you need to edit the interior, please click the \"Break up\" button",
    "k_8264de": "Scattered",
    "k_e10f8549": "If you just want to add some explanations and legends, it is not recommended to break them up-just put what you want to show above/below/to the right of the block",
    "k_d655a240": "Process: {arg_0} ",
    "k_20c18a37": "Data authorization",
    "k_c2ea3b00": "Mock: Process initiation page",
    "k_5ee019cb": "Open the process details page. {arg_0}",
    "k_3fa2551d": "Process Launch Page",
    "k_8c367c01": "Data: {arg_0} ",
    "k_3365518c": "The process editor is open. Remember to keep both sides",
    "k_f4ca7d2b": "To design the process",
    "k_f856cae2": "Reset block",
    "k_db73d5f3": "Default navigation",
    "k_97f1e51e": "Default menu",
    "k_7f13915d": "No",
    "k_c2809e98": "Failed to obtain page tag list:{arg_0}",
    "k_4603815f": "Failed to create label: {arg_0}",
    "k_8cd92570": "Failed to delete label:{arg_0}",
    "k_35683b1": "Failed to update label:{arg_0}",
    "k_c2737357": "Enter Save",
    "k_49e82653": "New label",
    "k_89ec450": "Label name cannot be empty",
    "k_8e07ad0e": "Creating duplicate tag names is not allowed",
    "k_b6a559cf": "Applicant",
    "k_ded521c7": "Application time",
    "k_83bea1b3": "Application configuration modifications have not been saved. Do you need to save and jump?",
    "k_93e0303a": "Without saving",
    "k_fddddb41": "Process configuration",
    "k_9375da1d": "All",
    "k_20ccf75a": "In the examination and approval",
    "k_d7ed9716": "Already through the",
    "k_865536c2": "Had rejected",
    "k_d1f52d91": "Search",
    "k_de4be22a": "Basic approval",
    "k_3c3c469": "Advanced Approval",
    "k_45670d5f": "Agree with the selection ( {arg_0} ) ",
    "k_533b498b": "Reject the selected ( {arg_0} ) ",
    "k_c2e098e6": "Preview",
    "k_e086749b": "Current node",
    "k_c11ad7f2": "Revoked (abort)",
    "k_36f12a9e": "The revoked",
    "k_414c29a7": "Unknown state",
    "k_69fe099b": "A total of {arg_0} pieces of data",
    "k_ce5b2b20": "Pending approval",
    "k_c30e0582": "My application",
    "k_fa7c8c7d": "Approved",
    "k_6f1bc870": "Relevant approval",
    "k_25e91e1d": "All approval",
    "k_438d1654": "Permission application",
    "k_296dc8e6": "Release approval",
    "k_1cff8eba": "Failed to obtain process configuration list",
    "k_6c9798cd": "Failed to obtain process instance",
    "k_5e31a56e": "Batch approval confirmation",
    "k_1871f86b": "Confirm the {arg_1} process orders that {arg_0} have been selected?",
    "k_e9fe0e6": "Confirm {arg_0}",
    "k_8c540d4d": "Batch approval was successful",
    "k_39079cae": "Batch approval failed",
    "k_6023fd58": "Failed to obtain process configuration",
    "k_43cfa86b": "Built-in page permissions",
    "k_992b625e": "Customize page permissions",
    "k_f9ff14e9": "Unrelated",
    "k_f2eb6e1c": "Please enter the page name or path to search",
    "k_ff558dc6": "Page label filtering",
    "k_468c01ad": "Overview",
    "k_3c5ef215": "Page view",
    "k_f11e4084": "Authorization ID",
    "k_a7974e2f": "Authority name",
    "k_80a2a191": "Hold authority",
    "k_807a75bc": "Please enter permission name to search",
    "k_7935122": "Batch authorize all pages in the application and use them with caution",
    "k_9bc3b3a0": "Please enter {arg_0} to search",
    "k_ae20c5cd": "New permissions: {arg_0}",
    "k_d9923c37": "Permission deleted: {arg_0}",
    "k_9309baf1": "Role permissions have been added",
    "k_ea46579a": "Role permissions have been deleted",
    "k_e7bff7c3": "Update failed",
    "k_88066a04": "Page permissions",
    "k_f191ffb9": "Process authority",
    "k_957c52fe": "Custom interface/collection permissions",
    "k_b9dd461": "Built-in permission",
    "k_18dc91ec": "1 day",
    "k_6f43158": "3 days",
    "k_fdc2ba01": "1 month",
    "k_232af8cb": "3 months",
    "k_e399f4b2": "1 year",
    "k_9c60fc86": "Permanent",
    "k_edacc123": "{arg_0} is an {arg_1} employee\n      , valid for up to {arg_2} days",
    "k_8994648d": "Validity period",
    "k_b466d9e7": "{arg_0} days",
    "k_3c6c1804": "Business",
    "k_82eeeb95": "Cloud Function Interface",
    "k_4a278e31": "Application type",
    "k_6b3f0f4a": "Apply for page permissions",
    "k_fee333d3": "Apply for role",
    "k_c8ecd215": "Search no results",
    "k_81d5cd37": "No roles available",
    "k_5b20d57": "Built-in roles cannot be applied",
    "k_10dd1820": "Context-based recommendations apply for the following roles",
    "k_9c3b7f23": "Please contact the administrator",
    "k_aad73cc": "Other roles (the following roles do not have permissions required by the context)",
    "k_240d2c9d": "Click to view role permissions:",
    "k_c26416e6": "Application description",
    "k_41ef5058": "Describe the action in progress so that administrators can assign the appropriate role",
    "k_273b1943": "Additional Forms",
    "k_18cd92c9": "View application data",
    "k_68c65e73": "New Application Data",
    "k_f712dbc7": "Updated application data",
    "k_533121a4": "Delete application data",
    "k_ebf73c10": "View data",
    "k_4fb1a4ab": "Update data",
    "k_a636c96f": "Delete data",
    "k_a5264345": "View permission configuration",
    "k_7ee7737e": "Update permissions configuration",
    "k_bf460c4d": "Upload in process",
    "k_4f2f0dca": "The role applied by the user does not exist",
    "k_2004bff5": "The role applied by the user does not have relevant permissions",
    "k_56859f51": "Obtaining permissions-Role failed",
    "k_37ea722": "Application role or page cannot be empty",
    "k_f98f26df": "Application description cannot be blank",
    "k_746f16a6": "Failed to verify additional form, {arg_0}",
    "k_3eccf63": "Unable to find the approver, please contact the administrator",
    "k_8ceaed29": "You can only select a maximum of 5 {arg_0}",
    "k_739c7620": "Approval authority application process",
    "k_7f5051ae": "You are not one of the approvers and cannot approve; but the administrator can reassign",
    "k_2018f27f": "Please select or search for approvers",
    "k_1bf9e1db": "Assign approvers",
    "k_73a865ad": "Please select an approver before assigning",
    "k_39198180": "Assignment successful",
    "k_4c339fae": "Failed to assign approvers",
    "k_8078ea79": "Operation agreed, role cannot be empty",
    "k_10b49971": "Approval failed",
    "k_26e09ec6": "Approval Form Details",
    "k_199ae69d": "Revoked",
    "k_3909871e": "Approval retry",
    "k_3f7e4afa": "Re-initiate approval",
    "k_16f3957b": "The notification plug-in prohibits the default approval operation. Please approve the approval on the \"{arg_0}\" side ",
    "k_60c78e5a": "The document does not exist or is not authorized to access it",
    "k_3b336c30": "Failed to obtain approval document",
    "k_4e1905c5": "Failed to obtain approval document record",
    "k_fb78182c": "Are you sure you want to cancel the current process order?",
    "k_20b502a3": "Description",
    "k_ff8f5383": "Failed to cancel order, {arg_0}",
    "k_868de658": "Determine the nodes that failed to retry the approval execution hook?",
    "k_bfbda1f9": "The same approval operation will be re-executed on the failed node. If multiple hook interfaces are configured on the node, it will be executed again regardless of whether it has been successfully executed or failed before",
    "k_8aaa3d2f": "Failed node: {arg_0}({arg_1})",
    "k_cb7d8494": "Retry failed, {arg_0}",
    "k_a0dbf204": "Re-initiating approval failed, {arg_0}",
    "k_fdfa100d": "No approval configuration found",
    "k_df7c42b": "Are you sure to re-initiate approval?",
    "k_79b0dd42": "It is detected that the current approval configuration is not associated with the initiation process page. The approval data cannot be modified. The original approval data will be used to initiate again.",
    "k_559254ce": "Loading...",
    "k_150f7b0c": "{{ state.pageTitle ||\"Process Example Details\" }}",
    "k_a71d1945": "Application",
    "k_141a5d19": "Return",
    "k_82560793": "Permission data environment is isolated, current environment: {arg_0}",
    "k_430e64f2": "Initialization has not been completed, and management on the infinite side is not supported yet. Please go to the Pangu side to manage the configuration yourself.",
    "k_60b884e": "Click to go to Pangu",
    "k_39f00e20": "Custom rights management",
    "k_e96f0e2c": "Quick selection:",
    "k_cd6f1ec1": "My Department",
    "k_5f810012": "My team",
    "k_3d6371ba": "Failed to add role ({arg_0}): {arg_1}",
    "k_f051deb9": "Saved",
    "k_b98b06bf": "Failed to add role",
    "k_68e5ce74": "Delete role failed",
    "k_bba19fb8": "Are you sure to delete the role?",
    "k_e29e8fe2": "Role will be deleted:",
    "k_503cf9cf": "User already exists",
    "k_db73a310": "User",
    "k_bd47c55f": "Organization",
    "k_48e1a139": "A business of",
    "k_984837d1": "Platform",
    "k_de89129e": "Application Type Role",
    "k_eb32103d": "Associated roles",
    "k_3ae666d6": "Add roles",
    "k_7a8ac438": "Click to display all (including expired ones)",
    "k_6640253": "Switch business",
    "k_b2e77f1f": "Platform (business irrelevant)",
    "k_5b92d69b": "Application type role, business irrelevant",
    "k_96900603": "The third-party authentication",
    "k_a7949555": "Platform Configuration-Runtime Custom Authentication",
    "k_dfc31757": "Failed to detect user rights",
    "k_a1b0c310": "Pangu",
    "k_e7d36e31": "Hold authority",
    "k_7694c3c6": "🚫No authority",
    "k_fced3053": "User has administrator status",
    "k_a1eee70d": "The administrator identity may come from: the manager in the application information, the developer of the development environment, the member of the administrator role in rights management, or the manager of the application group, etc.",
    "k_42c7e32b": "Authentication source",
    "k_8310307f": "Authentication result",
    "k_768dcf56": "Detect user rights",
    "k_70e17c63": "Please select",
    "k_bb1eab31": "Relevant page",
    "k_daa6ef15": "Related business",
    "k_5b70db1e": "Choose to isolate business",
    "k_7f714a86": "Detection",
    "k_9c08c159": "Platform (application type role)",
    "k_1fdff814": "Expiration time",
    "k_c4e4938d": "Open-ended",
    "k_48b09840": "All roles have been added",
    "k_4b975185": "Batch setting expiration time",
    "k_ad9f47e0": "Due within days",
    "k_f1e2574a": "Has expired",
    "k_4e3f19b7": "Days",
    "k_68232827": "Role type",
    "k_5a56f58": "Business isolation is not enabled",
    "k_285e70fe": "For example: admin-group",
    "k_476f8c20": "Example: Management Group",
    "k_b693096a": "Required",
    "k_d81995f": "Maximum length 36",
    "k_da7eafeb": "Valid characters: English letters, numbers, underscores and \"-\"",
    "k_3edf0dc6": "Role duplication",
    "k_dbd7eaf1": "Business cannot be blank",
    "k_a843d5b1": "Failed to add user ({arg_0}): {arg_1}",
    "k_31265e7c": "Failed to add {arg_0}",
    "k_7604490": "Failed to delete {arg_0}",
    "k_ade53e60": "Are you sure you want to delete {arg_0}?",
    "k_d9f53bd5": "{arg_0} will be deleted: ",
    "k_849e10c1": "Current association {arg_0}",
    "k_5034f108": "Add {arg_0}",
    "k_ba6eccf7": "Delete {arg_0}",
    "k_7687a68": "Start synchronization",
    "k_dd3467f4": "Synchronization",
    "k_4396725f": "Synchronization end",
    "k_d0d33fae": "Don't have permission to view the {arg_0} environment",
    "k_7348528b": "Failed to get {arg_0} list",
    "k_f78a44fb": "No right to update the target environment",
    "k_9f92c665": "Synchronization failed",
    "k_1fabec56": "Obtain",
    "k_1e042fbc": "Interface binding permissions",
    "k_9f480859": "Role permissions",
    "k_78725a7b": "Character user",
    "k_d9957ca5": "Successful",
    "k_3778c38b": "Failed, or already exists",
    "k_bef6644d": "Successfully synchronized permission configuration {arg_0}",
    "k_1a5d7b61": "Failed to synchronize permission configuration {arg_0}",
    "k_6c9e5e65": "Successfully synchronized role configuration {arg_0}",
    "k_78006865": "Failed to synchronize role configuration {arg_0}",
    "k_23ab5dc": "Permissions, interface relationships to which interface type permissions are bound, and collection related permissions will be synchronized",
    "k_96319495": "You can also synchronize through \"Sync Role Configuration\" with permissions",
    "k_afed0d0d": "The interface relationships of roles, permissions, role-permission bindings, and interface type permission bindings will be synchronized",
    "k_9822d682": "Non-existing permissions will be created simultaneously to the target environment, but relevant pages or data sources should be published to the target environment by publishing the version yourself.",
    "k_7dab916b": "Selection context",
    "k_b9188b41": "Permissions that require synchronization",
    "k_8ffb580f": "Roles that need to be synchronized",
    "k_cd73d5bb": "Sync to environment",
    "k_4037a536": "Sync Role-User",
    "k_c8585262": "Existing users in the target environment will not be deleted",
    "k_7d004e79": "Synchronization results",
    "k_32dc1804": "View results",
    "k_60223957": "Power authentication is not enabled in the target environment and cannot be synchronized",
    "k_f9c40765": "The target environment does not have read-only mode enabled and cannot be synchronized",
    "k_6ddc2455": "Synchronization is successful",
    "k_7c9ba730": "Synchronizing, please wait",
    "k_b5ed84dc": "Sync permission configuration",
    "k_c97fedf8": "Permission set",
    "k_4eaf42d1": "- Invalid organization, organization ID or changed",
    "k_1ca4c8ef": "Are you sure to delete the current role?",
    "k_2b34a388": "Note: All associated users will be deleted at the same time",
    "k_fba524bf": "Manage users/organizations",
    "k_1a8277ea": "Automatic maintenance by the system",
    "k_462c2438": "The role is a business type, but the application does not enable business isolation",
    "k_67c34774": "Add users",
    "k_b17dacd0": "Delete user",
    "k_1f52ee4": "Not yet connected with Pangu Organization",
    "k_fb22627": "Add an organization",
    "k_4e976195": "Delete an organization",
    "k_71c8bf13": "Built-in roles",
    "k_d63245c7": "Associated Users/Organizations",
    "k_d0aa278a": "Unlogged visitors",
    "k_c3e73a14": "All logged in users",
    "k_a3e59ae": "All users",
    "k_635baa4a": "Management Authority",
    "k_3216f2e1": "Role locked",
    "k_ee6e145b": "Administrative role",
    "k_ac16b642": "Modify role name",
    "k_61fc9306": "Permission with business isolation",
    "k_53385151": "{arg_0} (Click to copy)",
    "k_2ae74dbc": "{arg_0} has been copied",
    "k_9e91bf0d": " permissions",
    "k_f9df2bc3": " members",
    "k_a1ff13df": "Failed to obtain role and permission information",
    "k_69e7577f": "{arg_0} The environment has not been version released yet",
    "k_c99d5202": "Application generation process was successful",
    "k_f5b402c0": "Application generation process failed",
    "k_2315a75f": "Are you sure to generate a custom application process?",
    "k_50fe0311": "The permission application process is provided by the platform by default",
    "k_ac99a93a": "After generating the custom application process, you can",
    "k_8825ec5b": "Modify the approver, and the default approver is the application administrator role",
    "k_4c4392d8": "Add your own application success hook",
    "k_2450190d": "If you do not have the above requirements, you can use the application process provided by the platform",
    "k_38cb73cc": "Confirmed",
    "k_e28192b8": "Synchronizing role configuration",
    "k_c9d3e014": "Permission application settings",
    "k_fe7079e": "Click to view",
    "k_1e5e67d": "Click to generate",
    "k_ce387cff": "Platform-level custom authentication is enabled, the configuration here is invalid",
    "k_4321c5d6": "Third-party authentication is enabled, configuration here is invalid",
    "k_9a65512f": "No authorization to update, read-only mode",
    "k_fe8fea8e": "Not have permission to view",
    "k_14abaa91": "Search for roles",
    "k_78e4bcd3": "Please enter the role ID or role name keyword",
    "k_c362c204": "Edit role",
    "k_87aab406": "Manage {arg_0}",
    "k_88774c4d": " - Non-development environment, read-only",
    "k_44c27d31": "Permission application settings {arg_0}",
    "k_c7e104d6": "The following configurations require release to take effect in other environments",
    "k_4a4055f5": "Customize the permission application process",
    "k_9dfaf2ff": "If not, use the built-in permission application process",
    "k_b2198010": "Forbidden to apply for page permissions",
    "k_1da74fc4": "If you apply for page viewing permissions, the platform will automatically generate the/page-path role. The permissions of this role only have the viewing permissions of the page and cannot be changed",
    "k_a1294ecc": "Apply for role model",
    "k_38ebb325": "When users apply for multiple roles, should they be merged into one approval document or split into one role and one approval document?",
    "k_40ad95b3": "Combined",
    "k_76f2a305": "Split",
    "k_919b1a3d": "User/Organization Name",
    "k_e24b7360": "Expired disabled",
    "k_7bf35214": "In effect",
    "k_d21b3b20": "Expiration time",
    "k_50e4e26e": "Never expires",
    "k_fdebc213": "Expiration time set successfully",
    "k_2e211884": "Failed to set expiration time",
    "k_bb6333a6": "Set expiration time",
    "k_ed3d26bd": "Is selected",
    "k_dce870ec": "One",
    "k_98b78fee": "User or organization filtering",
    "k_b22ed9b5": "Expires within 7 days",
    "k_d52d4681": "Expires within 30 days",
    "k_31a1504c": "Total {arg_0} items",
    "k_5683e1fd": "Are you sure to remove the current user/organization?",
    "k_c84d71e6": "Note: All associated roles will be deleted at the same time",
    "k_6b46f5db": "Has been removed",
    "k_eee9c669": "Edit",
    "k_a76518bc": "Remove {arg_0}",
    "k_5fa3adcc": "Batch update expiration time",
    "k_c36a61ff": "Please enter your name to search",
    "k_5d8b172c": "Click the top-right button or press Esc key to exit full-screen mode",
    "k_10141502": "Exit full screen",
    "k_400a25f6": "Full screen",
    "k_809c3e0": "Extended fields must be legal JSON strings",
    "k_e27dd5a1": "Extended field must be an object",
    "k_1c9a79e0": "Extended fields cannot contain protected fields: {arg_0}",
    "k_f224cdea": "Valid characters: English letters, numbers, underscores,\"/\" and \"-\"",
    "k_b63055fd": "Duplicate permissions",
    "k_1860a3a8": "Maximum length 128",
    "k_4a513a38": "Unique identification",
    "k_999dc50d": "Extension field",
    "k_376eade4": "Permission type",
    "k_9afde246": "Permission name",
    "k_79a727c0": "Associated page",
    "k_440ece07": "If you do not fill in, you will associate all pages",
    "k_bc5b184b": "Please select the associated page. If you do not fill it in, you can use it on all pages",
    "k_31a492b": "Failed to detect permissions",
    "k_b8cdc90c": "Role members",
    "k_ca7b5b56": "Testing authority",
    "k_bbcce4bb": "Are you sure to delete the current permissions?",
    "k_8c823b1d": "Note: Bindings, such as role-permissions, interface-permissions, will also be deleted",
    "k_64fa6ed7": "Manage joins",
    "k_5cae64a4": "Data source interface",
    "k_d37bb59e": "More",
    "k_da76877a": "Modify permissions",
    "k_36c81048": "Are you sure you want to delete this interface association?",
    "k_ec5542bf": "Interface: {arg_0}",
    "k_122826e1": "Click X to delete the associated interface",
    "k_a04728a1": "Associated cloud functions (",
    "k_5ef054a": "Associated data sources (",
    "k_a4077aad": "Sync rights",
    "k_5eb79084": "Please enter permission name to search",
    "k_69d87f59": "Edit permissions",
    "k_dcdd0468": "Manage cloud function interfaces",
    "k_5b855952": "Manage data source interfaces",
    "k_f1d46da8": "Already associated",
    "k_880bbc42": "Correlated cloud function",
    "k_e69a7940": "Associated Data Source Interface",
    "k_8adeba38": "Binding success",
    "k_d9647ebe": "Bind failed",
    "k_5983b0b": "Binding permissions",
    "k_4398b947": "Choice Privileges",
    "k_6dc48d87": "Unbinding successfully",
    "k_f75d6f7d": "Unbinding failed",
    "k_aeff58dc": "Unbinding authority",
    "k_cb13275": "Permission has been bound",
    "k_b5667c73": "Select the permissions you need to unbind",
    "k_c78e6769": "Interface description",
    "k_e472b730": "No-",
    "k_f9000da6": " Binding permissions",
    "k_cd5a2be7": " Unbinding authority",
    "k_3575eef1": "There is no permission control by default",
    "k_2f0cfe64": "Remarks",
    "k_e1e0c09f": "Failed to obtain data source list",
    "k_3cc13c34": "\"{arg_0}\" permissions on the default binding page",
    "k_3e78c5f7": "Failed to obtain binding list",
    "k_929419a2": "Failed to obtain permission list",
    "k_bae007b1": "Enter the data source ID to search",
    "k_d90eef4f": "Enter the interface name to filter",
    "k_7e77ac95": "No permission",
    "k_2407fac5": "You are not an application group administrator",
    "k_d3b175fb": "Please select the {arg_0} page",
    "k_135d1f30": "{arg_0} page",
    "k_149994f4": "Edit Data Table Page",
    "k_becbfec9": "Edit page information",
    "k_623abe73": "New page",
    "k_8a854c12": "Copy page",
    "k_ced62b37": "Default primary key",
    "k_8d1bbf55": "{arg_0} Data source parsing failed. Please check the configuration of the authorization database",
    "k_1b584cc9": "Copy to clipboard: {arg_0}",
    "k_6b239e55": "The parameter format is incorrect and must be a JSON object",
    "k_3eeea282": "Parameters updated",
    "k_1f540ae3": "Add missing default parameters:",
    "k_e6b4477": "Delete undefined parameters:",
    "k_4b2db86b": "Unable to find process sheet with ID [{arg_0}]",
    "k_2c74e1a6": "If it is not enabled, the debugging function of the node will be invalid, and the process after startup cannot be used as a debugging archive point",
    "k_fcbe4cbd": "Debug mode",
    "k_ed54e318": "Immediately launched",
    "k_22799132": "Reset",
    "k_ceb8d591": "View Flowsheet",
    "k_fa950418": "Import from recent processes",
    "k_41344aba": "Set process startup parameters",
    "k_7bbf33ca": "Flowsheet information",
    "k_b3ed63cc": "Relevant approvers",
    "k_6a0d7436": "Process name",
    "k_73430bde": "Project ID",
    "k_a09831b3": "Environment ID",
    "k_9f8df386": "Process status (Chinese)",
    "k_491f2fc4": "Process initiation page url",
    "k_11083b9c": "Process version number",
    "k_296ad854": "Process messages",
    "k_952dbc02": "Request information to initiate the process (headers and cookies)",
    "k_12a4218a": "HTTP request header when initiating the process",
    "k_4fdb620a": "The cookie object when initiating the process",
    "k_60f2544f": "Creation time",
    "k_344a6a7": "Modification time",
    "k_fe6fe5d": "Project information",
    "k_ef09cdc7": "Project name",
    "k_cf04b993": "Format failed. Please check for syntax errors",
    "k_1ef05c7": "Edit process configuration directly",
    "k_c339c183": "Process data cannot be found",
    "k_81e6a815": "Unable to find copied process data",
    "k_6cfc561d": "Failed to obtain copied process data",
    "k_c0833ab7": "Change detected, saving",
    "k_7a6e52d0": "Process started",
    "k_ccfd3b42": "Ask the assistant for details",
    "k_535936bd": "Began",
    "k_fe92a5c5": "End",
    "k_70a725ee": "System default",
    "k_8beb24f1": "The new process must be saved before creating page slices",
    "k_1b19594d": "Failed to save page slice",
    "k_39a1a1af": "The page piece has been successfully created",
    "k_af45e966": "Page slice creation completed ",
    "k_e69af3f9": "Do you want to open a new edit page",
    "k_fbaf0ba5": "Go to the editor",
    "k_98a39580": "Save failed: {arg_0}",
    "k_f54346ca": "The approval plug-in has been successfully installed on the page piece",
    "k_8ff4521d": "Approval plug-in installation failed: {arg_0}",
    "k_2cfe9980": "Add page slices",
    "k_fd92c336": "Edit page piece",
    "k_9234cdca": "{arg_1} data in {arg_0}",
    "k_2b281888": "According to authority",
    "k_42595d24": "By role",
    "k_6bcd1f51": "The user has one of the following permissions",
    "k_f7272687": "The user is one of the following roles",
    "k_20995e58": "Authentication",
    "k_c5cd1cc2": "For example, the initiator job.creator or a specified user 'user_01', note the need for quotation marks",
    "k_9d3f1b2f": "Authentication configuration",
    "k_3bca261d": "Failure",
    "k_4ff13a9e": "Added",
    "k_ad5b5d5": "Remove users from the following roles {arg_0} ",
    "k_4ff1d92c": "Modify the configuration",
    "k_97b8405b": "Notification channels",
    "k_ed10a38f": "Unknown notification plugin-",
    "k_d2c7df0c": "Push message",
    "k_98cd6c4": "Output log",
    "k_690700f6": "Output",
    "k_d7eed04b": "Display on the details page",
    "k_b19aa852": "The form displayed on the details page",
    "k_7ae3fbc5": "After using custom page slices, you can design the appearance of the form and customize the front-end logic",
    "k_ce7731c0": "Enable notifications",
    "k_37fa99fd": "Notifier",
    "k_68a37c9a": "Notification configuration",
    "k_692f2e0b": "Condition judgment",
    "k_981c906": "Judgment condition",
    "k_53e3e1b5": "Determine whether the conditions are met",
    "k_ffd69665": "Is",
    "k_eb061075": "No",
    "k_1fef1bdb": "Form to initiate the process",
    "k_537d9a51": "You can use \"page slices\" to customize the appearance of the form and customize the front-end logic of the initiation process",
    "k_d3fd3a45": "After launching, hide it in the process sheet",
    "k_b95bde1f": "Next step",
    "k_6b66312": "DB data sources need to \"check response content\" to determine whether the read and write operation was successful",
    "k_92c65e55": "Help me configure",
    "k_3eb464f8": "Edit data source",
    "k_14f7e0fc": "Select data source",
    "k_b0f1c405": "Please select an interface",
    "k_149f1ae5": "After opening, request errors will not block the entire process, but will take the error handling branch",
    "k_f9e63f0": "When something goes wrong, use custom bottom-up logic",
    "k_c3981ec7": "If your service response is to return a field in the body to identify whether it was successful, please turn on this function and tell us how to determine whether it was successful.",
    "k_197f3b0": "The response content needs to be further checked to determine whether it was really successful",
    "k_612566b0": "Judgment logic",
    "k_15fb59a1": "Call data source",
    "k_1c464359": "Implementation",
    "k_2cfa60e3": "Data source interface collection",
    "k_cd2419b9": "Get request parameters",
    "k_c67a559f": "Enable error handling branches",
    "k_8f74ba4a": "Custom judgment logic",
    "k_c08c7c4f": "Request result",
    "k_9530e976": "Including response headers, response data, etc.",
    "k_8678758d": "Return data",
    "k_f7a3afda": "Back to head",
    "k_ae63372d": "\n* * http ** type data source is unique.\n\n* * Note: You must go to \"Interface Information\">\"Transparent Response Header\" in the data source configuration to configure the response headers you need to obtain. **\n              ",
    "k_384dac5c": "Error message (when an error occurs)",
    "k_9a237704": "JavaScript calculation result in the \"Parameters\" section of the corresponding node configuration",
    "k_877ae787": "{arg_0} times remaining",
    "k_82daae89": "The process level limit was exceeded by {arg_0} times! ",
    "k_211d1b64": "Regulation limiter",
    "k_aa0b8750": "Retry counter",
    "k_4f4ad7aa": "Number of retries",
    "k_63ee8239": "Note: You may need to configure the \"Maximum Number of Repeated Runs on a Single Node\" in the \"Process Details\"",
    "k_84af0546": "Retry interval (in seconds)",
    "k_e7ba9576": "Customize failure behavior",
    "k_7467a5be": "If it is not checked, the entire process will be determined to have failed directly after the number of retries exceeds",
    "k_b1d1861b": "Time of first retry",
    "k_f42c6df0": "Remaining Retries",
    "k_ba3f6931": "The time of each retry is recorded",
    "k_c03a57c0": "How many retry",
    "k_703f22d8": "Start retry time",
    "k_a6f9c066": "Are you sure you want to cancel the application of the associated database?",
    "k_12041509": "Unapplying the database may affect the data sources of other pages. Please proceed with caution",
    "k_33e64d51": "Table ID",
    "k_cba617ba": "Full release",
    "k_56a09f5": "Application publication",
    "k_f9b2777d": "Releasing services on a server in stages",
    "k_a068acf4": "Remove gray levels",
    "k_ae78d428": "Apply for rollback",
    "k_abac75c7": "Roll back grayscale",
    "k_ace63e62": "Call version interface",
    "k_910fa44b": "Configuration information",
    "k_b101992d": "Table version",
    "k_654d7067": "Row version",
    "k_280703a5": "Action",
    "k_160eef9a": "Enable error handling branch",
    "k_8cfc55ab": "After enabled, request errors will not block the entire process, but will take the error handling branch.",
    "k_169292d5": "Results",
    "k_5666a794": "Response to calling version interface",
    "k_34da32e8": "Initiate other processes",
    "k_80444691": "Process parameters (JS expressions)",
    "k_b8c1d45e": "Blank blank to use the initiator of the current process",
    "k_669ecee3": "Wait for process execution to end",
    "k_8a426cce": "If you do not check, the current process will continue directly after launching.\n\nWhether you wait or not, you can get the ID and URL of the initiated sub-process",
    "k_787a98e": "(After initiation) Process Order ID",
    "k_186c845a": "(After launch) Process sheet page url",
    "k_6cc002a8": "Actual process parameters (post-launch)",
    "k_aa161fd3": "Field data authorization",
    "k_ea60e439": "The page can only access data authorized here. Please do not disclose sensitive data to visitors",
    "k_a164ce2a": "Copy job. {arg_0}",
    "k_298b6bbe": "Replicated: {arg_0}",
    "k_396c78ad": "Updating authorization",
    "k_44766633": "Please use the [Top Toolbar] to authorize process data",
    "k_7aae26d0": "Authorize...",
    "k_182c1dbc": "[FlowPagePlugin] Page slice refresh failed",
    "k_4f10a338": "Approval page capabilities",
    "k_d302215b": "Used to render advanced processes",
    "k_3bf30d59": "Process node ID",
    "k_ebbdc26c": "Current process node",
    "k_9420c735": "Node ID",
    "k_4383df8a": "Promise AI plug-in",
    "k_ce3c0f9f": "Failed to obtain plug-in list:{arg_0}",
    "k_8868e509": "Failed to execute extension {arg_0}:{arg_1}",
    "k_b731bda1": "Failed to obtain extension",
    "k_12430b10": "No extensions available for debugging have been obtained yet:{arg_0}",
    "k_a5493960": "Failed to obtain plug-in list",
    "k_c33ffa3b": "Local debug plug-ins do not support uninstallation",
    "k_da65f7c3": "Failed to obtain application template list {arg_0}",
    "k_a48be2c4": "Failed to obtain the list of customized application templates {arg_0}",
    "k_b26e8e3": "Failed to obtain application template {arg_0}:{arg_1}",
    "k_f9d1a346": "Failed to get local draft: {arg_0}",
    "k_23039328": "Failed to get remote draft: {arg_0}",
    "k_68cee761": "Failed to obtain modification record {arg_0}",
    "k_d5be9068": "Module name cannot be empty",
    "k_9a44218f": "Module names consist of letters, numbers, underscores, and dash lines, and can only start with letters and end with.js / .ts",
    "k_9d2db9a7": "The module name already exists",
    "k_2078e7b7": "Enter the module name ending in.js or.ts, and press Enter to confirm",
    "k_dc811e1a": "Failed to obtain modification record with id {arg_0}: {arg_1}",
    "k_d1eccb74": "Failed to get the list of modification records for type {arg_0}: {arg_1}",
    "k_c3f5f2f5": "Failed to save modification record of type {arg_0}: {arg_1}",
    "k_de14bfcb": "Default store",
    "k_52695b8e": "Failed to obtain application list for application group",
    "k_6eff55b9": "Failed to obtain component template list {arg_0}",
    "k_9fe36397": "Failed to obtain component template",
    "k_c529ef0e": "Template updated successfully",
    "k_657c06a5": "Template created successfully",
    "k_5ca18ed8": "Failed to obtain list of manageable component templates",
    "k_686f6bd": "Template deleted successfully",
    "k_ffe59be0": "Template deletion failed",
    "k_11b9501a": "Base version",
    "k_59d525e1": "Local version",
    "k_4bd99660": "Select incorporated version",
    "k_7fdaf451": "Select current version",
    "k_9b14774e": "No content to merge",
    "k_41d8db3f": "Code merge failed",
    "k_20a14c1f": "Submission description cannot be empty",
    "k_f0e9b9b0": "No changes were selected",
    "k_fa62b53b": "[{arg_0}] Data merge failed. Please check whether there are still unresolved conflicts",
    "k_e89b7cbb": "Submit a change",
    "k_7f3f72ef": "Version release",
    "k_85e3c58": "Submit information (required)",
    "k_cc4dec15": "Submitted",
    "k_f7744109": "Code merge",
    "k_d93e2bd2": "Code merge calculation, please wait patiently",
    "k_78de0700": "Branch name cannot be empty",
    "k_5a431063": "Failed to obtain branch list",
    "k_55911220": "Failed to obtain branch information",
    "k_3b2b0cfd": "Automatically switch to development branch",
    "k_4d749f19": "Failed to obtain the user's current development branch",
    "k_54cd1351": "Switch to the {arg_0} branch soon",
    "k_ac626b79": "Failed to switch branch",
    "k_a700ac50": "Failed to get uncommitted changes",
    "k_a8e848c3": "Failed to obtain submission record",
    "k_1c797d5b": "Failed to obtain latest version of branch",
    "k_15c8585b": "Pull",
    "k_b4e8c8b3": "There are no {arg_0} submissions",
    "k_6cc53065": "Merge branches {arg_0} to {arg_1}",
    "k_d856cd82": "Submitted successfully",
    "k_a0145225": "Submission failed",
    "k_4967384a": "Reset commit operation failed",
    "k_43174be1": "Failed to pull whether the application updates data:",
    "k_e0714093": "Failed to pull whether the application updates data: {arg_0}",
    "k_48909764": "Failed to update application data:",
    "k_2f39dc14": "Failed to update application data: {arg_0}",
    "k_f3e275b3": "Failed to obtain project announcement list: {arg_0}",
    "k_33798af5": "Announcement has been deleted",
    "k_f9999817": "Failed to delete announcement: {arg_0}",
    "k_89a06b47": "Updated announcement",
    "k_fcd0d673": "Failed to update announcement: {arg_0}",
    "k_c52c1c1f": "Announcement created",
    "k_ead414b4": "Failed to create announcement: {arg_0}",
    "k_6b50b91d": "Failed to obtain project ticker announcement list: {arg_0}",
    "k_2d538e8e": "Failed to modify read status: {arg_0}",
    "k_5cdbb884": "Failed to obtain data table list: {arg_0}",
    "k_1ede4f9d": "Failed to pull material data: {arg_0}",
    "k_db7c9be": "Failed to obtain announcement data",
    "k_f2013b94": "Failed to obtain announcement record",
    "k_34bbca7d": "The task failed. Please export again",
    "k_80f3136a": "Wait for the task export to complete...",
    "k_16426b18": "Download link is empty and cannot be downloaded",
    "k_ccd14fad": "Ongoing",
    "k_ee447943": "Failed to obtain offline list",
    "k_56d4aed": "Failed to obtain historical version number",
    "k_a02e7f65": "Offline task created successfully",
    "k_3271f4c3": "Offline task creation failed: {arg_0}",
    "k_8385a3b8": "Offline records have been deleted",
    "k_772c7f8b": "Failed to delete offline records: {arg_0}",
    "k_8246609d": "Failed to obtain offline configuration list",
    "k_9d3170": "Offline configuration created successfully",
    "k_2ff0711d": "Offline configuration creation failed: {arg_0}",
    "k_8cdae68e": "Offline configuration update successfully",
    "k_71d36515": "Offline configuration update failed",
    "k_43b6adee": "Offline configuration update failed: {arg_0}",
    "k_16856889": "Offline configuration has been deleted: {arg_0}",
    "k_98276eb2": "Failed to delete offline configuration",
    "k_42198a43": "Failed to delete offline configuration: {arg_0}",
    "k_c9ea45c8": "Configuration function debugging successfully",
    "k_14ae8f47": "Configuration function debugging failed",
    "k_d386f50e": "Configuration function debugging failed: {arg_0}",
    "k_c6e60898": "Infinite Default Skin",
    "k_837f8fe6": "The returned data is empty",
    "k_c12582ce": "Failure to obtain skin",
    "k_bf75cf46": "Failed to obtain skin data {arg_0}",
    "k_35e4efe4": "Unable to get skin {arg_0}",
    "k_832a33c5": "Failed to get skin demo page",
    "k_4112a0f5": "Not authorized to call",
    "k_52cab8eb": "Do not have permission to initiate the process, click",
    "k_c7216872": "Application authority",
    "k_487ec374": "Open applications are not allowed to modify data, only allow data to be read",
    "k_75e7b96e": "Request timeout",
    "k_4db76250": "Request failed: code={arg_0}, msg={arg_1}",
    "k_dc58f3b6": "The current login session has expired. Please login again.",
    "k_746118cd": "The current login session has been exited. Please log in again",
    "k_5d795f1f": "Due to platform security policy update, please log in again",
    "k_d0ced744": "It is detected that the login status has expired. Please log in again.",
    "k_bbac3a15": "Login failed, please click login again",
    "k_aab0b579": "Login status has expired",
    "k_f0f5041b": "Logged-in",
    "k_bd106100": "Log back in",
    "k_f2bf1a48": "Failed to obtain organizational structure information,{arg_0}",
    "k_2ad68317": "Reload the entire page",
    "k_397e6bad": "Editor is connected",
    "k_2fe6ef49": "Connected editor",
    "k_69fc76d9": "Editor is not connected",
    "k_76555706": "Page configuration has been updated",
    "k_6f84ebfd": "Local refresh {arg_0}",
    "k_42f5e81": "Refresh {arg_0}",
    "k_1d3baf61": "Template management",
    "k_b877305": "Public account",
    "k_f96d3365": "Application group",
    "k_98babb0e": "Component Store",
    "k_48959f5c": "Authority center",
    "k_fb51ac48": "Use document",
    "k_8c20c8e3": "Data management",
    "k_3ecad5e3": "Application management",
    "k_93102939": "Failed to obtain application and page data: {arg_0}",
    "k_d2824d4c": "Currently in debug mode",
    "k_e364cd2e": "Path is not defined and cannot be previewed",
    "k_e8683a42": "Failed to pull the page list in debug mode. Please confirm whether local development services are enabled",
    "k_e7c85d6e": "This page has no path configured and cannot be redirected",
    "k_42c616d": "Simulation",
    "k_22b120d0": "Not logged in",
    "k_1d2f5881": "Personal information",
    "k_135046b9": "Key",
    "k_83ca1f6d": "Acquire the key",
    "k_a28cbb88": "Restore supervisor or operation and maintenance identity",
    "k_a0e9c968": "Experience non-super management or operation and maintenance identity",
    "k_a12d4022": "Failed to obtain key: {arg_0}",
    "k_d617030f": "Copy key",
    "k_26da8aec": "Get the secret key",
    "k_8023b7cf": "Copying failed! {arg_0}",
    "k_70f1cb93": "Click to expand more",
    "k_4d5b2a1a": "Operation is not supported in preview mode",
    "k_30cfdf6e": "Environment name",
    "k_68bca42a": "Production environment",
    "k_4a921bf": "Environment options cannot be empty",
    "k_ce82051f": "Environment configuration has duplicate options '{arg_0}'",
    "k_9db94d9": "Fast switching",
    "k_bb6f8ae6": "Failed to obtain application short path configuration",
    "k_2a4064b1": "Failed to delete short path configuration",
    "k_347eff79": "This navigation group [{arg_0}] has no configuration page menu",
    "k_6928183e": "Failed to obtain approval list",
    "k_1295f1e4": "Failed to obtain approval process",
    "k_64e75f8": "Incorrect approval initiated",
    "k_d5973ce4": "Approval page",
    "k_3c94703e": "You have {arg_0} pending approvals",
    "k_3fe9f956": "Generating...",
    "k_30128ce0": "The server has deserted, please regenerate the QR code",
    "k_a47439da": "Modifying pages",
    "k_7d696af7": "Apply permissions",
    "k_4f874193": "My clearance",
    "k_a8ca6093": "New user registration approval",
    "k_4268ef72": "Application Group Management",
    "k_f535605c": "Restoring the administrator role",
    "k_ba2913ff": "Experience non-administrator roles",
    "k_f45002d2": "Exit simulated login",
    "k_8ea489b5": "Promise 1.0",
    "k_34f3e9c4": "Inherited from organization",
    "k_e62b00e2": "Apply for renewal",
    "k_8e3162d6": "Click the role name to view detailed permissions",
    "k_52fbb473": "Bulletin centre",
    "k_9a9f48cf": "Expand to view details",
    "k_768c4341": "No announcement",
    "k_1eba2d58": "Know",
    "k_c8816485": "Main menu switching",
    "k_15bad987": "Powered by Promise",
    "k_336bd15c": "Sidebar.setCurrentGroup: Unable to find {arg_0} menu group",
    "k_df44eb0c": "Failed to obtain route from menu",
    "k_26d0e628": "You are experiencing a non-administrator role",
    "k_b8617726": "Informal settings",
    "k_8368999a": "Page {arg_0} ",
    "k_a2c7c623": "Developer tools",
    "k_f9a00d11": "Close other",
    "k_7df3dcc9": "Local cache",
    "k_d54f44cc": "Dependency updates...",
    "k_a3e8ffd": "Depending on the update success, the page is about to be refreshed",
    "k_abcaa87f": "The page you are looking for does not seem to exist?",
    "k_f09521e9": "Home",
    "k_a969dc32": "Don't have permission to access",
    "k_dc80ae0a": "Please try",
    "k_b7bbfe82": "Visit again later",
    "k_935f4bcc": "Login",
    "k_6baf464c": "Note: Permission data environment isolation, current environment",
    "k_54628b5c": "Failed to verify permissions",
    "k_3e273a3": "Failed to pull global variable configuration. Please confirm whether the local CLI service is started, or upgrade the CLI tool: {arg_0}",
    "k_3681939": "Unable to load the current page, missing page id definition",
    "k_22a6adc8": "A new version of the page has been released",
    "k_9ec0f0c2": "You can click or refresh the page to experience it!🚀🚀🚀",
    "k_4a80970c": "[mock] Failed to obtain page data",
    "k_87c18e28": "[mock] Data saved successfully",
    "k_b52320f0": "Mock data editing",
    "k_7f2ecb8c": "Mock title",
    "k_73ac7b18": "Slot",
    "k_9dcca78d": "Event",
    "k_93c3ab41": "Component linkage method",
    "k_b5adc2c7": "Unknown page {arg_0}",
    "k_f78edf42": "Parameters within component- {arg_0}",
    "k_2f75416b": "Please drag the component here",
    "k_13385176": "Data sources within component",
    "k_ee0fa40a": "Open the Component Editor",
    "k_468714ae": "Open the edit page of this component",
    "k_d9e6b92c": "Don't prompt",
    "k_dc158dd2": "Please use the component in the page that opens",
    "k_31e6e541": ", check the debugging results",
    "k_81386661": "In this editor, clicking the save button (or pressing ctrl/cmd + s) will trigger an update of the debugging page",
    "k_9d098c4c": "Please note: Do not refresh the debugging page, otherwise the hot update will be invalid.",
    "k_78c9cbee": "Failed to check permissions",
    "k_116c2c08": "Component name",
    "k_f472612a": "Number of leaks",
    "k_6c8982be": "Execution path",
    "k_dd04ffae": "Query parameter tool",
    "k_432bf6f0": "Convert to filter array",
    "k_473a7ed6": "Option",
    "k_82cefc2e": "Convert to filter expression",
    "k_af2f5511": "Convert to a nested filter expression",
    "k_38327a82": "Filter In nested format, and and or must be arrays",
    "k_19aebe28": "In filter nested format, there can only be one and or on an object",
    "k_c58fcf59": "Hook Key",
    "k_f243599d": "Returned data",
    "k_b39805f": "Received data",
    "k_9c7b0f59": "The URL to continue the flow. External systems can continue the flow by POSTing data to this address:\n`{arg_0}`",
    "k_56789109": "{\n  // You can return data to the caller as needed\n}"
};
